import axios from '@/utils/axios'

/**
 *  年度协议列表
 */
export function agreementPage (parameter) {
  return axios.formRequest.post('order/website/agreement/page', parameter)
}

/**
 *  年度协议详情
 */
export function agreementDetail (order_agreement_id) {
  return axios.formRequest.post('order/website/agreement/detail', {
    order_agreement_id
  })
}

/**
 *  年度协议删除
 */
export function agreementDel (order_agreement_id) {
  return axios.formRequest.post('order/website/agreement/del', {
    order_agreement_id
  })
}

/**
 *  审批条件
 */
export function conditionList () {
  return axios.formRequest.post('order/website/order/conditionList', {})
}

/**
 *  税率列表
 */
export function rateList () {
  return axios.formRequest.post('order/website/contract/rateList', {})
}

/**
 *  税率设置
 */
export function rateSet (json) {
  return axios.formRequest.post('order/website/contract/rate', {
    json
  })
}

/**
 *  流向迁移日志记录
 */
export function batchMoveLog (parameter) {
  return axios.formRequest.post('flow/website/flow/batchMoveLog', parameter)
}

/**
 *  流向迁移日志详情记录
 *  batch_flow_log_id
 *  page
 */
export function batchMoveInfoLog (parameter) {
  return axios.formRequest.post('flow/website/flow/batchMoveInfoLog', parameter)
}

/**
 *  流向迁移日志详情记录 删除
 *  batch_flow_info_log_id
 */
export function delMoveInfoLog (parameter) {
  return axios.formRequest.post('flow/website/flow/delMoveInfoLog', parameter)
}

/**
 *  购销合同列表
 */
export function contractPage (parameter) {
  return axios.formRequest.post('order/website/contract/page', parameter)
}

/**
 *  购销合同删除
 */
export function contractDel (order_contract_id) {
  return axios.formRequest.post('order/website/contract/del', {
    order_contract_id
  })
}

/**
 *  购销合同详情
 */
export function contractDetail (order_contract_id) {
  return axios.formRequest.post('order/website/contract/detail', {
    order_contract_id
  })
}

/**
 *  购销合同购货单位列表
 */
export function contractClientList (parameter = {}) {
  return axios.formRequest.post('order/website/contract/clientList', parameter)
}

/**
 *  购销合同采购产品
 */
export function contractGoodsList (parameter) {
  return axios.formRequest.post('order/website/contract/goodsList', parameter)
}

/**
 *  购销合同添加
 */
export function contractAdd (parameter) {
  return axios.formRequest.post('order/website/contract/add', parameter)
}

/**
 *  购销合同编辑
 */
export function contractEdit (parameter) {
  return axios.formRequest.post('order/website/contract/edit', parameter)
}

/**
 *  首营资质列表
 */
export function qualificationPage (parameter) {
  return axios.formRequest.post('order/website/qualification/page', parameter)
}

/**
 *  首营资质删除
 */
export function qualificationDel (order_qualification_id) {
  return axios.formRequest.post('order/website/qualification/del', {
    order_qualification_id
  })
}

/**
 *  首营资质添加
 */
export function qualificationAdd (parameter) {
  return axios.formRequest.post('order/website/qualification/add', parameter)
}

/**
 *  首营资质编辑
 */
export function qualificationEdit (parameter) {
  return axios.formRequest.post('order/website/qualification/edit', parameter)
}

/**
 *  库房列表
 */
export function housePage (parameter) {
  return axios.formRequest.post('order/website/house/page', parameter)
}

/**
 *  库房删除
 */
export function houseDel (order_ware_house_id) {
  return axios.formRequest.post('order/website/house/del', {
    order_ware_house_id
  })
}

/**
 *  库房添加
 */
export function houseAdd (parameter) {
  return axios.formRequest.post('order/website/house/add', parameter)
}

/**
 *  库房编辑
 */
export function houseEdit (parameter) {
  return axios.formRequest.post('order/website/house/edit', parameter)
}

/**
 *  红点
 */
export function qualificationRed (parameter) {
  return axios.formRequest.post(
    'order/website/qualification/haveRed',
    parameter
  )
}

/**
 *  红点点击
 */
export function qualificationClick (parameter) {
  return axios.formRequest.post('order/website/qualification/click', parameter)
}

/**
 *  订单列表
 */
export function orderPage (parameter) {
  return axios.formRequest.post('order/website/order/page', parameter)
}

/**
 *  订单详情
 */
export function orderDetail (parameter) {
  return axios.formRequest.post('order/website/order/detail', parameter)
}

/**
 *  订单删除
 */
export function orderDel (order_id) {
  return axios.formRequest.post('order/website/order/del', {
    order_id
  })
}

/**
 *  订单添加
 */
export function orderAdd (parameter) {
  return axios.formRequest.post('order/website/order/add', parameter)
}

/**
 *  订单编辑
 */
export function orderEdit (parameter) {
  return axios.formRequest.post('order/website/order/edit', parameter)
}

/**
 *  订单产品列表
 */
export function orderGoodsList (parameter) {
  return axios.formRequest.post('order/website/order/goodsList', parameter)
}

/**
 *  年度协议产品列表
 */
export function getGoodsList (name, client_id) {
  return axios.formRequest.post('order/website/agreement/getGoodsList', {
    name,
    client_id
  })
}

/**
 *  年度协议添加
 */
export function agreementAdd (parameter) {
  return axios.formRequest.post('order/website/agreement/add', parameter)
}

/**
 *  自报填写时间列表
 *  cls,
 *  year
 */
export function selfReportDateList (parameter) {
  return axios.formRequest.post('crm/website/self_report/dateList', parameter)
}

/**
 *  自报内容配置
 *  cls,
 *  type
 */
export function selfReportSetting (parameter) {
  return axios.formRequest.post('crm/website/self_report/setting', parameter)
}

/**
 *  编辑自报时间
 */
export function selfReportEditDate (parameter) {
  return axios.formRequest.post('crm/website/self_report/editDate', parameter)
}

/**
 *  年度协议编辑
 */
export function agreementEdit (parameter) {
  return axios.formRequest.post('order/website/agreement/edit', parameter)
}

/**
 *  自报操作日志
 */
export function selfReportLog (parameter) {
  return axios.formRequest.post('log/website/log/getPage', parameter)
}

/**
 *  自报操作日志
 */
export function selfReportPage (parameter) {
  return axios.formRequest.post('crm/website/self_report/page', parameter)
}

/**
 *  全年终端自报数据
 */
export function clientYearReport (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/clientYearReport',
    parameter
  )
}

/**
 *  终端涉及产品
 */
export function clientGoodsList (client_id) {
  return axios.formRequest.post('crm/website/self_report/goodsList', {
    client_id
  })
}

/**
 *  自报导出
 */
export function selfReportExport (parameter) {
  return axios.formRequest.post('crm/website/self_report/export', parameter)
}

/**
 *  自报填写权限配置列表
 */
export function settingJobList (cls) {
  return axios.formRequest.post('crm/website/self_report/settingJobList', {
    cls
  })
}

/**
 *  自报填写权限配置（岗位）
 */
export function settingJob (parameter) {
  return axios.formRequest.post('crm/website/self_report/settingJob', parameter)
}

/**
 *  自报导入下载模版 验证用
 */
export function selfReportDownModelJudge (parameter) {
  return axios.formRequest.post('crm/website/self_report/downModel', {
    ...parameter,
    is_judge: 1
  })
}

/**
 *  填报时间段
 */
export function selfReportFillDate (cls) {
  return axios.formRequest.post('crm/website/self_report/fillDate', {
    cls
  })
}

/**
 *  悦来圈 云拜访 病例收集
 */
export function ylqMedicalPage (parameter) {
  return axios.formRequest.post('yht/website/outside/medicalPage', parameter)
}

/**
 *  悦来圈 云拜访 病例导出
 */
export function ylqExportRecordPhoto (parameter) {
  return axios.formRequest.post(
    'yht/website/outside/exportRecordPhoto',
    parameter
  )
}

/**
 *  悦来圈 云拜访 病例详情
 */
export function ylqMedicalDetail (parameter) {
  return axios.formRequest.post('yht/website/outside/medicalDetail', parameter)
}

/**
 *  悦来圈 云拜访 病例详情 标记和取消优秀病例
 */
export function ylqChangeExcellent (parameter) {
  return axios.formRequest.post(
    'yht/website/outside/changeExcellent',
    parameter
  )
}

/**
 *  医生列表
 */
export function outsideDoctorPage (parameter) {
  return axios.formRequest.post('yht/website/outside/doctorPage', parameter)
}

/**
 *  医生详情
 */
export function outsideDoctorDetail (doctor_id) {
  return axios.formRequest.post('yht/website/outside/doctorDetail', {
    doctor_id
  })
}

/**
 *  店员列表
 */
export function outsideAssistantPage (parameter) {
  return axios.formRequest.post('yht/website/outside/assistantPage', parameter)
}

/**
 *  医生解绑
 */
export function outsideDoctorUntying (doctor_id) {
  return axios.formRequest.post('yht/website/outside/doctorUntying', {
    doctor_id
  })
}

/**
 *  获取任务所有控件
 */
export function visitTemplateField (template_id, finish_time) {
  return axios.formRequest.post('crm/website/visit/templateField', {
    template_id,
    finish_time
  })
}

/**
 *  药店详情
 */
export function outsideClientAssistantDetail (client_id) {
  return axios.formRequest.post('yht/website/outside/clientAssistantDetail', {
    client_id
  })
}

/**
 *  店员解绑
 *  assistant_id = account_id
 */
export function outsideAssistantUntying (assistant_id) {
  return axios.formRequest.post('yht/website/outside/assistantUntying', {
    assistant_id
  })
}

/**
 *  竞品列表
 */
export function vieGoodsPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/vieGoodsPage',
    parameter
  )
}

/**
 *  创建竞品
 */
export function createVieGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/createVieGoods',
    parameter
  )
}

/**
 *  编辑竞品
 */
export function updateVieGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/updateVieGoods',
    parameter
  )
}

/**
 *  竞品详情
 */
export function detailVieGoods (goods_id) {
  return axios.formRequest.post('masterdata/website/goods/detailVieGoods', {
    goods_id
  })
}

/**
 *  删除竞品
 */
export function delVieGoods (goods_id) {
  return axios.formRequest.post('masterdata/website/goods/delVieGoods', {
    goods_id
  })
}

/**
 *  通用码
 */
export function companyCommonCode () {
  return axios.formRequest.post('yht/website/outside/companyCommonCode', {})
}

/**
 *  云拜访 积分列表
 */
export function outsideScorePage (parameter) {
  return axios.formRequest.post('yht/website/outside/scorePage', parameter)
}

/**
 *  云拜访 功能设置详情
 */
export function outsideSettingDetail () {
  return axios.formRequest.post('yht/website/outside/settingDetail', {})
}

/**
 *  云拜访 功能设置
 */
export function outsideSetting (config) {
  return axios.formRequest.post('yht/website/outside/setting', {
    config
  })
}

/**
 *  云拜访 积分设置列表
 */
export function scoreSettingList () {
  return axios.formRequest.post('yht/website/outside/scoreSettingList', {})
}

/**
 *  云拜访 积分设置
 */
export function scoreSetting (yhq_score_type_id, score) {
  return axios.formRequest.post('yht/website/outside/scoreSetting', {
    yhq_score_type_id,
    score
  })
}

/**
 *  处方单购买渠道
 */
export function prescriptionOrderChannelList () {
  return axios.formRequest.post(
    'masterdata/website/prescription_order/channelList',
    {}
  )
}

/**
 *  处方单列表
 */
export function prescriptionOrderPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/prescription_order/page',
    parameter
  )
}

/**
 *  处方单详情
 */
export function prescriptionOrderDetail (prescription_order_id) {
  return axios.formRequest.post(
    'masterdata/website/prescription_order/detail',
    {
      prescription_order_id
    }
  )
}
/**
 *  处方单审核
 */
export function prescriptionOrderCheck (parameter) {
  return axios.formRequest.post(
    'masterdata/website/prescription_order/check',
    parameter
  )
}

/**
 *  处方单 导出
 */
export function prescriptionOrderExport (parameter) {
  return axios.formRequest.post(
    'masterdata/website/prescription_order/export',
    parameter
  )
}

/**
 *  业务指导 翻页列表
 */
export function directPage (parameter) {
  return axios.formRequest.post('crm/website/direct/directPage', parameter)
}

/**
 *  业务指导 指导部门列表
 */
export function directDepList () {
  return axios.formRequest.post('crm/website/direct/depList', {})
}

/**
 *  业务指导 添加部门
 */
export function directDepAdd (parameter) {
  return axios.formRequest.post('crm/website/direct/depAdd', parameter)
}

/**
 *  业务指导 编辑部门
 */
export function directDepEdit (parameter) {
  return axios.formRequest.post('crm/website/direct/depEdit', parameter)
}

/**
 *  业务指导 删除部门
 */
export function directDepDel (parameter) {
  return axios.formRequest.post('crm/website/direct/depDel', parameter)
}

/**
 *  业务指导 导出
 */
export function exportDirect (parameter) {
  return axios.formRequest.post('crm/website/export/exportDirect', parameter)
}

/**
 *  业务指导 详情
 */
export function directDetail (crm_direct_id) {
  return axios.formRequest.post('crm/website/direct/directDetail', {
    crm_direct_id
  })
}

/**
 *  添加指导意见
 */
export function replyAdd (parameter) {
  return axios.formRequest.post('crm/website/direct/replyAdd', parameter)
}

/**
 *  编辑指导意见
 */
export function replyEdit (parameter) {
  return axios.formRequest.post('crm/website/direct/replyEdit', parameter)
}

/**
 *  查看签到地图
 */
export function visitSignDetail (parameter) {
  return axios.formRequest.post('crm/website/visit/signDetail', parameter)
}

/**
 *  三者关系操作日志列表
 */
export function jurisdictionLog (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/target/logPage',
    parameter
  )
}

/**
 *  三者关系操作日志列表 导出
 */
export function jurisdictionLogExport (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportLogPage',
    parameter
  )
}

/**
 *  三者关系操作对象
 */
export function jurisdictionLogSceneList () {
  return axios.formRequest.post('jurisdiction/website/target/sceneList', {})
}

/**
 *  三者关系操作内容
 */
export function jurisdictionLogTypeList () {
  return axios.formRequest.post('jurisdiction/website/target/typeList', {})
}

/**
 *  流向迁移日志
 */
export function flowTransferLog (parameter) {
  return axios.formRequest.post('flow/website/flow/flowTransferLog', parameter)
}

/**
 *  云拜访 资料详情
 */
export function questionnaireResult (parameter) {
  return axios.formRequest.post(
    'crm/website/questionnaire/questionnaireResult',
    parameter
  )
}

/**
 *  云拜访 资料详情
 */
export function answerPage (parameter) {
  return axios.formRequest.post(
    'crm/website/questionnaire/answerPage',
    parameter
  )
}

/**
 *  配置保存 type config[json]
 */
export function specialSave (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/specialSave',
    parameter
  )
}

/**
 *  组织架构涉及月份
 */
export function departmentHistoryMonth (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/departmentHistoryMonth',
    parameter
  )
}

/**
 *  备案列表
 */
export function accountRecordPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/recordPage',
    parameter
  )
}

/**
 *  备案详情
 */
export function accountRecordDetail (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/recordDetail',
    parameter
  )
}

/**
 *  备案删除
 */
export function accountRecordDel (id, function_name) {
  return axios.formRequest.post('jurisdiction/website/Account/del', {
    id,
    function_name
  })
}

/**
 *  关账销售数据汇总
 */
export function getFlowLockTotal (parameter) {
  return axios.formRequest.post('flow/website/flow/getFlowLockTotal', parameter)
}

/**
 *  销售数据统计总计
 */
export function getFlowTotal (parameter) {
  return axios.formRequest.post('flow/website/flow/getFlowTotal', parameter)
}

/**
 *  备案添加
 */
export function recordAdd (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/recordAdd',
    parameter
  )
}

/**
 *  备案编辑
 */
export function recordEdit (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/editor',
    parameter
  )
}

/**
 *  商业销售统计
 */
export function clientSalesStats (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/clientSalesStats',
    parameter
  )
}

/**
 *  移动端 流向查询列表
 */
export function getFlowPage (parameter) {
  return axios.formRequest.post('flow/website/flow/flowPage', parameter)
}

/**
 *  获取档案选项类自定义字段
 */
export function getClientCustomList (cls) {
  return axios.formRequest.post('flow/website/stats/getClientCustomList', {
    cls
  })
}

/**
 *  导出商业统计
 */
export function exportClientSalesStats (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportClientSalesStats',
    parameter
  )
}

/**
 * 校验服务商名称
 */
export function checkServerClient (name) {
  return axios.formRequest.post('masterdata/website/client/checkServerClient', {
    name
  })
}

/**
 * 档案分类下所有字段
 */
export function getAllFields (cls_id) {
  return axios.formRequest.post('masterdata/website/field/getAllFields', {
    cls_id
  })
}

/**
 * 服务商账号列表
 */
export function serverClientAccountPage (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/serverClientAccountPage',
    parameters
  )
}

/**
 * 选择上游列表
 */
export function clientPage (parameters) {
  return axios.formRequest.post('/masterdata/website/client/page', parameters)
}

/**
 * 服务商账号详情
 */
export function serverClientAccountInfo (server_client_id) {
  return axios.formRequest.post(
    '/mango/website/serverclient/serverClientAccountInfo',
    {
      server_client_id
    }
  )
}

/**
 * 重置服务商密码
 */
export function resetPassword (server_client_id, server_client_account_id) {
  return axios.formRequest.post('/mango/website/serverclient/resetPassword', {
    server_client_id,
    server_client_account_id
  })
}

/**
 * 停用服务商账号
 */
export function stopServerClientAccount (
  server_client_id,
  server_client_account_id,
  stop_type
) {
  return axios.formRequest.post(
    '/mango/website/serverclient/stopServerClientAccount',
    {
      server_client_id,
      server_client_account_id,
      stop_type
    }
  )
}

/**
 * 创建、编辑服务商账号
 */
export function setServerClientAccount (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/setServerClientAccount',
    parameters
  )
}

/**
 * 企业模版列表
 */
export function serverclientTemplateList (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/templateList',
    parameters
  )
}

/**
 * 启用
 */
export function openServerClientAccount (server_client_id) {
  return axios.formRequest.post(
    '/mango/website/serverclient/openServerClientAccount',
    {
      server_client_id
    }
  )
}

/**
 * 服务商销售关系列表
 */
export function serverClientMapList (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/serverClientMapList',
    parameters
  )
}

/**
 * 服务商销售关系详情
 */
export function serverClientMapInfo (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/serverClientMapInfo',
    parameters
  )
}

/**
 * 解除绑定关系
 */
export function unbindServerClient (client_id, server_client_id) {
  return axios.formRequest.post(
    '/mango/website/serverclient/unbindServerClient',
    {
      client_id,
      server_client_id
    }
  )
}

/**
 * 关联项目服务商列表
 */
export function getServerClientByClientId (client_id) {
  return axios.formRequest.post(
    '/mango/website/serverclient/getServerClientByClientId',
    {
      client_id
    }
  )
}

/**
 * 关联服务商人员列表
 */
export function getServerAccountByClientId (client_id) {
  return axios.formRequest.post(
    '/mango/website/serverclient/getServerAccountByClientId',
    {
      client_id
    }
  )
}

/**
 * 工业段登录详情 用来查看账号使用情况
 */
export function mongoDetail (client_id) {
  return axios.formRequest.post('/jurisdiction/website/login/mongoDetail', {
    client_id
  })
}

/**
 * 服务商报告统计列表
 */
export function ServerClientReportList (parameters) {
  return axios.formRequest.post(
    '/mango/website/report/ServerClientReportList',
    parameters
  )
}

/**
 * 获取芒哥工业版配置
 */
export function mgGetSetting () {
  return axios.formRequest.post('/mango/website/setting/getSetting', {})
}

/**
 * 设置芒哥工业版配置
 */
export function mgSetting (parameters) {
  return axios.formRequest.post('/mango/website/setting/setting', parameters)
}

/**
 * 服务商模版报告统计列表
 */
export function serverClientTemplateList (server_client_id, is_person) {
  return axios.formRequest.post(
    '/mango/website/report/serverClientTemplateList',
    {
      server_client_id,
      is_person
    }
  )
}

/**
 * 报告字段接口
 */
export function get_template_field (template_id) {
  return axios.formRequest.post('/mango/website/report/get_template_field', {
    template_id
  })
}

/**
 * 报告字段 服务商
 */
export function getTemplateFieldService (template_id) {
  return axios.formRequest.post('/empower/website/empower/get_template_field', {
    template_id
  })
}

/**
 * 报告列表
 */
export function reportDataList (parameters) {
  return axios.formRequest.post(
    '/mango/website/report/reportDataList',
    parameters
  )
}

/**
 * 生成临时pdf
 */
export function pdfCreate (parameters) {
  return axios.formRequest.post('/mango/website/report/pdfCreate', parameters)
}

/**
 * 导出报告
 */
export function exportReport (parameters) {
  return axios.formRequest.post(
    '/mango/website/export/exportReport',
    parameters
  )
}

//服务商列表
export function page (parameters) {
  return axios.formRequest.post('/masterdata/website/client/page', parameters)
}

/**
 * 报告导出
 */
export function reportExport (parameter) {
  return axios.formRequest.post(
    '/serverclient/website/export/reportExport',
    parameter
  )
}

/**
 * 获取模版和报告数量接口
 */
export function getTemplateReportNumber (parameter) {
  return axios.formRequest.post(
    '/empower/website/empower/getTemplateReportNumber',
    parameter
  )
}

/**
 * 添加账号选择人员列表
 */
export function chooseAccount (parameter) {
  return axios.formRequest.post(
    '/serverclient/website/account/chooseAccount',
    parameter
  )
}

/**
 *  批量审批产品组筛选
 */
export function getGoodsNameList () {
  return axios.formRequest.post(
    'masterdata/website/agency_relation/getGoodsNameList',
    {}
  )
}

/**
 * 系统自检 列表
 */
export function checkPage (parameter) {
  return axios.formRequest.post('/masterdata/website/check/page', parameter)
}

/**
 * 系统自检 自检设置
 */
export function checkSetting (parameter) {
  return axios.formRequest.post('/masterdata/website/check/setting', parameter)
}

/**
 * 系统自检 自检详情
 */
export function checkSettingRow (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/check/settingRow',
    parameter
  )
}

/**
 * 系统自检 详情
 */
export function checkDetail (parameter) {
  return axios.formRequest.post('/masterdata/website/check/detail', parameter)
}

/**
 * 系统自检 立刻自检
 */
export function checkCheck (parameter) {
  return axios.formRequest.post('/masterdata/website/check/check', parameter)
}

/**
 * 获取选择协防人、活动成员配置
 */
export function getTaskActivitySetting () {
  return axios.formRequest.post(
    'crm/website/setting/getTaskActivitySetting',
    {}
  )
}

/**
 * 设置选择协防人、活动成员配置
 */
export function setTaskActivitySetting (setting) {
  return axios.formRequest.post('crm/website/setting/setTaskActivitySetting', {
    setting
  })
}

/**
 * 取消代理关系
 */
export function agencyRelationCancel (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/agency_relation/cancel',
    parameter
  )
}

/**
 * 取消代理关系
 */
export function agencyRelationDel (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/agency_relation/del',
    parameter
  )
}

/**
 * 获取跨省流向配置
 */
export function getProvinceFlowSetting (parameter) {
  return axios.formRequest.post(
    '/flow/website/setting/getProvinceFlowSetting',
    parameter
  )
}

/**
 * 选择跨省流向档案
 */
export function chooseProvinceFlowClient (parameters) {
  return axios.formRequest.post(
    '/flow/website/setting/chooseProvinceFlowClient',
    parameters
  )
}

/**
 * 选择跨省流向档案
 */
export function setProvinceFlowSetting (parameters) {
  return axios.formRequest.post(
    '/flow/website/setting/setProvinceFlowSetting',
    parameters
  )
}

/**
 * 考勤标签列表
 */
export function attendanceGetTagList (parameters) {
  return axios.formRequest.post(
    '/crm/website/attendance/getTagList',
    parameters
  )
}

/**
 * 编辑考勤标签
 */
export function attendanceTagEdit (parameters) {
  return axios.formRequest.post('/crm/website/attendance/tagEdit', parameters)
}

/**
 * 问卷等级列表
 */
export function doctorQuestionLevelQuestionPage (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/questionPage',
    parameter
  )
}

/**
 * 添加一个空白问卷
 */
export function doctorQuestionLevelAdd (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/add',
    parameter
  )
}

/**
 * 删除问卷
 */
export function doctorQuestionLevelDel (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/del',
    parameter
  )
}

/**
 * 品种筛选
 */
export function doctorQuestionLevelGoodsList (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/goodsList',
    parameter
  )
}

/**
 * 问卷产品配置
 */
export function doctorQuestionLevelGoodsSetting (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/goodsSetting',
    parameter
  )
}

/**
 * 表达式添加
 */
export function doctorQuestionLevelAddExpression (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/addExpression',
    parameter
  )
}

/**
 * 定级问卷详情
 */
export function doctorQuestionLevelQuestionDetail (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/doctor_question_level/questionDetail',
    parameter
  )
}

/**
 * 服务商准入权限查看
 */
export function businessEntrySettingRow (parameter) {
  return axios.formRequest.post(
    '/crm/website/business_entry/settingRow',
    parameter
  )
}

/**
 * 服务商准入权限配置
 */
export function businessEntrySettingEdit (parameter) {
  return axios.formRequest.post(
    '/crm/website/business_entry/settingEdit',
    parameter
  )
}

/**
 * 服务商准入列表
 */
export function businessEntrySettingPage (parameter) {
  return axios.formRequest.post('/crm/website/business_entry/page', parameter)
}

/**
 * 服务商准入导出
 */
export function businessEntrySettingExport (parameter) {
  return axios.formRequest.post('/crm/website/business_entry/export', parameter)
}

/**
 * 服务商准入详情
 */
export function businessEntrySettingDetail (parameter) {
  return axios.formRequest.post('/crm/website/business_entry/detail', parameter)
}

/**
 * 获取销售指标设置
 */
export function settingGetSaleIndexConfig (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/setting/getSaleIndexConfig',
    parameter
  )
}

/**
 * 设置销售指标配置
 */
export function settingSavelIndexConfig (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/setting/savelIndexConfig',
    parameter
  )
}

/**
 * 按档案统计销售指标列表
 */
export function saleindexSaleIndexByClientList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/saleindex/saleIndexByClientList',
    parameter
  )
}

/**
 * 按部门统计销售指标列表
 */
export function saleindexSalesIndexByDepartmentList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/saleindex/salesIndexByDepartmentList',
    parameter
  )
}

/**
 * 按岗位统计销售指标列表
 */
export function saleindexSalesIndexByQuarterList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/saleindex/salesIndexByQuarterList',
    parameter
  )
}

/**
 * 按产品统计销售指标列表
 */
export function saleindexSaleIndexByGoodsList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/saleindex/saleIndexByGoodsList',
    parameter
  )
}

/**
 * 更新联系人导出表格
 */
export function exportUpdateContacts (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportUpdateContacts',
    parameter
  )
}

/**
 * 删除联系人导出表格
 */
export function exportDelContacts (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportDelContacts',
    parameter
  )
}

/**
 * 配置详情
 */
export function crmStatementActivitySettingRow (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/settingRow',
    parameters
  )
}

/**
 * 配置保存
 */
export function crmStatementActivitySetting (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/setting',
    parameters
  )
}

/**
 * 职位筛选
 */
export function crmStatementActivityFilter (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/filter',
    parameters
  )
}

/**
 * 拜访kpi统计列表
 */
export function crmStatementActivityKpiPage (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/kpiPage',
    parameters
  )
}

/**
 * 项目报告数据列表
 */
export function serverClientReportStatistics (parameters) {
  return axios.formRequest.post(
    '/mango/website/serverclient/serverClientReportStatistics',
    parameters
  )
}

/**
 *  项目报告数据导出
 */
export function exportSeverClientReportStatistics (parameter) {
  return axios.formRequest.post(
    '/mango/website/export/exportSeverClientReportStatistics',
    parameter
  )
}

/**
 *  关联关系导出
 */
export function exportSeverClientMap (parameter) {
  return axios.formRequest.post(
    '/mango/website/export/exportSeverClientMap',
    parameter
  )
}

/**
 * 直辖岗位
 */
export function crmStatementActivityDirectPage (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/directPage',
    parameters
  )
}

/**
 * 活动数据统计列表
 */
export function crmStatementActivityPage (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/page',
    parameters
  )
}

/**
 * 拜访路线效率报告
 */
export function crmStatementLinePage (parameters) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/LinePage',
    parameters
  )
}

/**
 *  按岗位统计销售指标历史数据导出
 */
export function exportSaleIndexQuarterHistory (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexQuarterHistory',
    parameter
  )
}

/**
 *  按档案统计销售指标历史数据导出
 */
export function exportSaleIndexClientHistory (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexClientHistory',
    parameter
  )
}

/**
 *  获取页面筛选排序
 */
export function getFilterSortInfo (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/getFilterSortInfo',
    parameter
  )
}

/**
 *  设置页面筛选排序
 */
export function setFilterSortInfo (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Account/setFilterSortInfo',
    parameter
  )
}

/**
 *  协防人员配置
 */
export function xfTypeSetting (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/xfTypeSetting',
    parameter
  )
}

/**
 *  获取问卷选择项
 */
export function doctorQuestionLevelquestionList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_question_level/questionList',
    parameter
  )
}

/**
 *  导出等级问卷
 */
export function doctorQuestionLevelExport (parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_question_level/export',
    parameter
  )
}

/**
 *  工商局信息展示
 */
export function getBusinessDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getBusinessDetail',
    parameter
  )
}

/**
 *  人均拜访分析
 */
export function visitAnalysePage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/visit_analyse/page',
    parameter
  )
}

/**
 *  筛选职位显示配置保存
 */
export function screenJobSetting (parameter) {
  return axios.formRequest.post(
    'crm/website/setting/screenJobSetting',
    parameter
  )
}

/**
 *  工作报告人员筛选列表（周报、月报用）
 */
export function reportAccountList (parameter) {
  return axios.formRequest.post(
    'crm/website/report/reportAccountList',
    parameter
  )
}

/**
 *  获取筛选职位显示配置
 */
export function getScreenJobSetting (parameter) {
  return axios.formRequest.post(
    'crm/website/setting/getScreenJobSetting',
    parameter
  )
}

/**
 *  档案审批记录
 */
export function clientApprovalDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/clientApprovalDetail',
    parameter
  )
}

/**
 *  删除拜访指标
 */
export function delTaskIndex (parameter) {
  return axios.formRequest.post('crm/website/setting/delTaskIndex', parameter)
}

/**
 *  岗位销售数据统计合计
 */
export function quarterStats (parameter) {
  return axios.formRequest.post('flow/website/stats/quarterStats', parameter)
}

/**
 *  岗位-按历史组织结构查看销售数据统计合计
 */
export function flowHistoryQuarterStats (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_history/quarterStats',
    parameter
  )
}

/**
 *  部门销售数据统计合计
 */
export function departmentStats (parameter) {
  return axios.formRequest.post('flow/website/flow/departmentStats', parameter)
}

/**
 *  历史部门销售数据统计合计
 */
export function flowHistoryDepartmentStats (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_history/departmentStats',
    parameter
  )
}

/**
 *  省份销售数据统计合计
 */
export function provinceStats (parameter) {
  return axios.formRequest.post('flow/website/stats/provinceStats', parameter)
}

/**
 *  产品销售数据统计合计
 */
export function goodsStats (parameter) {
  return axios.formRequest.post('flow/website/stats/goodsStats', parameter)
}

/**
 *  终端进货分析统计合计
 */
export function clientSalesSum (parameter) {
  return axios.formRequest.post('flow/website/stats/clientSalesSum', parameter)
}

/**
 *  获取档案待处理
 */
export function getPendingClient (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/getPendingClient', parameter)
}
/**
 *  获取档案待处理 分页信息
 */
export function getPendingClientPageInfo (parameter = {}) {
  return axios.formRequest.post(
    '/flow/website/flow/getPendingClientPageInfo',
    parameter
  )
}

/**
 *  获取档案批量处理
 */
export function batchMatch (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/batchMatch', parameter)
}
/**
 *  获取档案批量处理保存
 */
export function batchMatchOp (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/batchMatchOp', parameter)
}

/**
 * 分词保存
 */
export function addDic (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/addDic', parameter)
}

/**
 *  获取分词
 */
export function getDic (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/getDic', parameter)
}

/**
 *  获取产品待处理
 */
export function getPendingGoods (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/getPendingGoods', parameter)
}
/**
 *  获取产品待处理 分页信息
 */
export function getPendingGoodsPageInfo (parameter = {}) {
  return axios.formRequest.post(
    '/flow/website/flow/getPendingGoodsPageInfo',
    parameter
  )
}

/**
 *  待处理手动匹配
 */
export function manualRefreash (parameter = {}) {
  return axios.formRequest.post('flow/website/flow/manualRefreash', parameter)
}

/**
 *  待处理新增档案
 */
export function manualAddClient (parameter) {
  return axios.formRequest.post('flow/website/flow/manualAddClient', parameter)
}

/**
 * 竞品（品规）
 */
export function departmentVieGoods (name) {
  return axios.formRequest.post('masterdata/website/goods/departmentVieGoods', {
    name
  })
}

/**
 * 有映射的产品（产品别名库）
 */
export function goodsScreen (parameter = {}) {
  return axios.formRequest.post(
    'flow/website/goods_alias/goodsScreen',
    parameter
  )
}

/**
 * 设置停用岗位隐藏配置
 */
export function stopQuarterSetting (parameter = {}) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/stopQuarterSetting',
    parameter
  )
}

/**
 * 编辑市场部关联接口
 */
export function clientMaketRelation (parameter = {}) {
  return axios.formRequest.post(
    'masterdata/website/client_maket/relation',
    parameter
  )
}

/**
 * 编辑市场部关联显示以选择的岗位
 */
export function clientMaketRelationQuarter (parameter = {}) {
  return axios.formRequest.post(
    'masterdata/website/client_maket/relationQuarter',
    parameter
  )
}

/**
 * 编辑市场部关联显示以选择的岗位
 */
export function clientTaskAndFlow (parameter = {}) {
  return axios.formRequest.post(
    'masterdata/website/client/taskAndFlow',
    parameter
  )
}

/**
 *  查看网抓账号密码
 */
export function getWebscrapPassword (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getWebscrapPassword',
    parameter
  )
}

/**
 *  未覆盖数列表
 */
export function noCoverPage (parameter) {
  return axios.formRequest.post('masterdata/wap/third/noCoverPage', parameter)
}

/**
 *  未覆盖数详情
 */
export function pharmacyInfo (parameter) {
  return axios.formRequest.post('masterdata/wap/third/pharmacyInfo', parameter)
}

/**
 *  未覆盖数详情
 */
export function closeDevelopment (parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital/closeDevelopment',
    parameter
  )
}

/**
 *  获取配置接口 (指标达成表头)
 */
export function getSaleIndexTitle (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Setting/getSaleIndexTitle',
    parameter
  )
}

/**
 *  设置配置接口 (指标达成表头)
 */
export function setSaleIndexTitle (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Setting/setSaleIndexTitle',
    parameter
  )
}

/**
 *  产品管理 (工业库存 列表)
 */
export function goodsStock (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/goodsStock',
    parameter
  )
}

/**
 *  设置配送商定级方式
 */
export function saveDistributorLevel (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/saveDistributorLevel',
    parameter
  )
}

/**
 *  编辑配送商等级
 */
export function editDistributorLevel (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/editDistributorLevel',
    parameter
  )
}

/**
 *  推送详情接口 (H5)
 */
export function videoPushDetail (parameter) {
  return axios.formRequest.post('api/website/video/pushDetail', parameter)
}

/**
 *  原始数据地区销售金额产品占比
 */
export function originStatsByGoods (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/originStatsByGoods',
    parameter
  )
}

/**
 *  原始数据购进客户类型占比
 */
export function originStatsByCls (parameter) {
  return axios.formRequest.post('flow/website/flow/originStatsByCls', parameter)
}

/**
 *  原始数据按省份统计
 */
export function originStatsByProvince (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/originStatsByProvince',
    parameter
  )
}

/**
 *  设置重点产品
 */
export function setFlowOriginalGoods (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setFlowOriginalGoods',
    parameter
  )
}

/**
 *  获取档案类型 （日月报数据查看》表格数据）
 */
export function getOpenCustomClient (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getOpenCustomClient',
    parameter
  )
}

/**
 *  报表设置 （日月报数据查看》表格数据）
 */
export function setFlowOriginalShow (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setFlowOriginalShow',
    parameter
  )
}

/**
 *  获取销售指标档案类型
 */
export function getSaleIndexQuarterCls (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/Setting/getSaleIndexQuarterCls',
    parameter
  )
}

/**
 *  获取销售指标职位显示配置
 */
export function getSaleIndexJobConfig (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/getSaleIndexJobConfig',
    parameter
  )
}

/**
 *  设置销售指标职位显示配置
 */
export function setSaleIndexJobConfig (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/setSaleIndexJobConfig',
    parameter
  )
}

/**
 *  档案处于退回状态，恢复为正常状态
 */
export function returnToNormal (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/returnToNormal',
    parameter
  )
}

/**
 *  档案处于退回状态，恢复为正常状态
 */
export function titleList (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/titleList',
    parameter
  )
}

/**
 *  档案处于退回状态，恢复为正常状态
 */
export function titleSave (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/titleSave',
    parameter
  )
}

/**
 *  原始数据按上级供应商统计
 */
export function originStatsBySuperior (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/originStatsBySuperior',
    parameter
  )
}
/**
 *  原始数据按上级供应商统计 分页信息
 */
export function getOriginStatsBySuperiorPageInfo (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getOriginStatsBySuperiorPageInfo ',
    parameter
  )
}
/**
 *  导出原始数据统计-按商业 (异步)
 */
export function exportFlowOriginalSuperior (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowOriginalSuperior',
    parameter
  )
}

/**
 *  导出原始数据统计-按省份 (异步)
 */
export function exportFlowOriginalProvince (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowOriginalProvince',
    parameter
  )
}

/**
 *  菜单提示
 */
export function commonTipsMenu (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/common/tipsMenu',
    parameter
  )
}

/**
 *  销售指标分配设置 按三者关系
 */
export function settingSetSaleIndexTitle (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/setSaleIndexTitle',
    parameter
  )
}

/**
 *  获取 目标工作天数
 */
export function getWorkNumber (parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/getWorkNumber',
    parameter
  )
}

/**
 *  备案代表详情
 */
export function recordDetail (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/account/recordDetail',
    parameter
  )
}

/**
 *  连锁品牌数据
 */
export function searchList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/brand/searchList',
    parameter
  )
}

/**
 *  部门分销率
 */
export function departmentSalesRate (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentSalesRate',
    parameter
  )
}

/**
 *  部门分销率
 */
export function provinceSalesRateDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/provinceSalesRateDetail',
    parameter
  )
}

/**
 *  产品分销趋势
 */
export function salesTrend (parameter) {
  return axios.formRequest.post('crm/website/goods_sales/salesTrend', parameter)
}

/**
 *  产品分销率
 */
export function goodsSalesRate (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/goodsSalesRate',
    parameter
  )
}

/**
 *  部门分销率 分销率明细
 */
export function departmentSalesRateDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentSalesRateDetail',
    parameter
  )
}

/**
 *  部门平均陈列面
 */
export function departmentDisplay (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentDisplay',
    parameter
  )
}

/**
 *  平均陈列面
 */
export function averageDisplay (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/averageDisplay',
    parameter
  )
}

/**
 *  部门平均陈列面明细
 */
export function departmentDisplayDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentDisplayDetail',
    parameter
  )
}

/**
 *  标准陈列面设置列表
 */
export function displayList (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/displayList',
    parameter
  )
}

/**
 *  保存标准陈列面数
 */
export function displaySave (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/displaySave',
    parameter
  )
}

/**
 *  部门陈列位置（好位置分布）
 */
export function departmentGoodsLocation (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentGoodsLocation',
    parameter
  )
}

/**
 *  部门陈列位置明细
 */
export function departmentGoodsLocationDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentGoodsLocationDetail',
    parameter
  )
}

/**
 *  陈列位置（好位置分布）
 */
export function goodsLocationDistribute (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/goodsLocationDistribute',
    parameter
  )
}

/**
 *  部门终端库存
 */
export function departmentClientStock (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentClientStock',
    parameter
  )
}

/**
 *  按省份终端库存
 */
export function provinceClientStock (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/provinceClientStock',
    parameter
  )
}

/**
 *  终端库存趋势
 */
export function clientStockTrend (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/clientStockTrend',
    parameter
  )
}

/**
 *  终端库存
 */
export function clientStock (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/clientStock',
    parameter
  )
}

/**
 *  部门终端库存明细
 */
export function departmentClientStockDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentClientStockDetail',
    parameter
  )
}

/**
 *  产品终端价格
 */
export function goodsClientPrice (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/goodsClientPrice',
    parameter
  )
}

/**
 *  部门终端平均价格
 */
export function departmentClientPrice (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentClientPrice',
    parameter
  )
}

/**
 *  按省份终端平均价格
 */
export function provinceDepartmentClientPrice (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/provinceDepartmentClientPrice',
    parameter
  )
}

/**
 *  部门终端平均价格明细
 */
export function departmentClientPriceDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/departmentClientPriceDetail',
    parameter
  )
}

/**
 *  终端价格趋势
 */
export function clientPriceTrend (parameter) {
  return axios.formRequest.post(
    'crm/website/goods_sales/clientPriceTrend',
    parameter
  )
}

/**
 *  医院科室架构 导出模版
 */
export function departmentLevelExport (parameter) {
  return axios.formRequest.post(
    'masterdata/website/department_level/export',
    parameter
  )
}

/**
 *  医院科室架构 职位配置列表
 */
export function departmentLevelSettingList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/department_level/settingList',
    parameter
  )
}

/**
 *  医院科室架构 职位配置
 */
export function departmentLevelSetting (parameter) {
  return axios.formRequest.post(
    'masterdata/website/department_level/setting',
    parameter
  )
}

/**
 *  导出终端签约量分配
 */
export function exportContractedTemplate (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportContractedTemplate',
    parameter
  )
}

/**
 *  模版添加-作战地图
 */
export function battleMapTemplateAdd (parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/add',
    parameter
  )
}

/**
 *  模版详情-作战地图
 */
export function battleMapTemplateDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/detail',
    parameter
  )
}

/**
 * 作战地图-导出数据
 */
export function battleMapTemplateExport (parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/export',
    parameter
  )
}

/**
 *  获取自报周期
 */
export function selfReportFillDateList (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/fillDateList',
    parameter
  )
}

/**
 *  获取 目标工作天数
 */
export function getPeriod (parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/getPeriod',
    parameter
  )
}

/**
 *  网抓账号列表
 */
export function webscrapAccountList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/webscrapAccountList',
    parameter
  )
}

/**
 *  设置网抓账号
 */
export function setWebscrapAccount (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setWebscrapAccount',
    parameter
  )
}

/**
 *  删除账号
 */
export function delWebscrapAccount (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/delWebscrapAccount',
    parameter
  )
}

/**
 *  获取 目标工作天数
 */
export function getTemplateReportInfo (parameter) {
  return axios.formRequest.post(
    'crm/website/template/getTemplateReportInfo',
    parameter
  )
}

/**
 *  获取 自报详情 拜访协防详情
 */
export function visitReportData (parameter) {
  return axios.formRequest.post('crm/website/visit/reportData', parameter)
}

/**
 *  档案子公司列表
 */
export function getubsidiaryRow (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getubsidiaryRow',
    parameter
  )
}

/**
 *  获取 档案合并记录
 */
export function transferLogPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/Transfer/transferLogPage',
    parameter
  )
}

/**
 *  原始数据按省份统计2
 */
export function originStatsByProvinceTotalByGoods (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/originStatsByProvinceTotalByGoods',
    parameter
  )
}

/**
 *  医生估量列表
 */
export function doctorValuePage (parameter) {
  return axios.formRequest.post(
    'crm/website/doctor_value/doctorValuePage',
    parameter
  )
}

/**
 *  医生估量导出
 */
export function doctorValueExport (parameter) {
  return axios.formRequest.post(
    'crm/website/doctor_value/exportDoctorValue',
    parameter
  )
}

/**
 *  医生估量下载模版
 */
export function doctorValueDownModel (parameter) {
  return axios.formRequest.post('crm/website/doctor_value/downModel', parameter)
}

/**
 *  导出流向覆盖统计（浙江医药提）
 */
export function flowCoverageStatistics (parameter) {
  return axios.formRequest.post(
    'flow/website/export/flowCoverageStatistics',
    parameter
  )
}

/**
 *  绩效考核（获取权重，考核项最大值）
 */
export function getHighScore (parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/getHighScore',
    parameter
  )
}

/**
 *  获取 控件显示隐藏数据
 */
export function widgetDetail (parameter) {
  return axios.formRequest.post('crm/website/visit/widgetDetail', parameter)
}

/**
 *  设置档案自定义名称
 */
export function setCustomClientName (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setCustomClientName',
    parameter
  )
}

/**
 *  费控系统 产品价格信息列表
 */
export function costGoodsPage (parameter) {
  return axios.formRequest.post('cost/website/goods/goodsPage', parameter)
}

/**
 *  费控系统 产品详情接口
 */
export function costGoodsDetail (parameter) {
  return axios.formRequest.post('cost/website/goods/goodsDetail', parameter)
}

/**
 *  费控系统 设置产品价格
 */
export function costGoodsSetGoodsPrice (parameter) {
  return axios.formRequest.post('cost/website/goods/setGoodsPrice', parameter)
}

/**
 *  费控系统 选择厂家
 */
export function industrialPage (parameter) {
  return axios.formRequest.post('flow/website/stats/industrialPage', parameter)
}

/*
 * 费控系统 选择产品
 * */
export function costGoodsList (parameter) {
  return axios.formRequest.post('cost/website/goods/goodsList', parameter)
}

/**
 *  费控系统 获取数据字典列表
 */
export function getDictionaryList (parameter) {
  return axios.formRequest.post(
    'cost/website/dictionary/getDictionaryList',
    parameter
  )
}

/**
 *  费控系统 获取数据字典
 */
export function DictionaryList (parameter) {
  return axios.formRequest.post(
    'cost/website/dictionary/DictionaryList',
    parameter
  )
}

/**
 *  费控系统 设置数据字典
 */
export function setDictionary (parameter) {
  return axios.formRequest.post(
    'cost/website/dictionary/setDictionary',
    parameter
  )
}

/**
 *  费控系统 收款账户列表
 */
export function collectionAccountPage (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/collectionAccountPage',
    parameter
  )
}

/**
 *  费控系统 导出收款账户导入模版
 */
export function exportCollectionAccountTemplate (parameter) {
  return axios.formRequest.post(
    'cost/website/export/exportCollectionAccountTemplate',
    parameter
  )
}

/**
 *  费控系统 导出终端价格备案
 */
export function exportTerminalPrice (parameter) {
  return axios.formRequest.post(
    'cost/website/export/exportTerminalPrice',
    parameter
  )
}

/**
 *  费控系统 收款账户详情
 */
export function collectionDetail (parameter) {
  return axios.formRequest.post('cost/website/collection/detail', parameter)
}

/**
 *  费控系统 编辑收款账户
 */
export function collectionEditor (parameter) {
  return axios.formRequest.post('cost/website/collection/editor', parameter)
}

/**
 *  费控系统 停用账户
 */
export function stopCollectionAccount (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/stopCollectionAccount',
    parameter
  )
}

/**
 *  费控系统 启用账户
 */
export function openCollectionAccount (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/openCollectionAccount',
    parameter
  )
}

/**
 *  费控系统 删除账户
 */
export function delCollectionAccount (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/delCollectionAccount',
    parameter
  )
}

/**
 *  费控系统 终端价格备案列表
 */
export function cosTerminalPricePage (parameter) {
  return axios.formRequest.post('cost/website/terminal_price/page', parameter)
}

/**
 *  费控系统 删除终端价格备案
 */
export function DelTerminalPrice (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/delTerminalPrice',
    parameter
  )
}

/**
 *  费控系统 终端价格备案详情
 */
export function TerminalPriceDetail (parameter) {
  return axios.formRequest.post('cost/website/terminal_price/detail', parameter)
}

/**
 *  费控系统 创建终端价格备案
 */
export function CreateTerminalPrice (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/createTerminalPrice',
    parameter
  )
}

/**
 *  费控系统 编辑终端价格备案
 */
export function editTerminalPrice (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/editTerminalPrice',
    parameter
  )
}

/**
 *  费控系统 创建收款账户
 */
export function collectionCreate (parameter) {
  return axios.formRequest.post('cost/website/collection/create', parameter)
}

/**
 *  费控系统 流向列表
 */
export function costFlowPage (parameter) {
  return axios.formRequest.post('cost/website/flow/flowPage', parameter)
}

/**
 *  费控系统 流向详情
 */
export function costFlowDetail (parameter) {
  return axios.formRequest.post('cost/website/flow/detail', parameter)
}

/**
 *  费控系统 备案获取
 */
export function TerminalPriceObtain (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/TerminalPriceObtain',
    parameter
  )
}

/**
 *  费控系统 导出流向
 */
export function costExportFlow (parameter) {
  return axios.formRequest.post('cost/website/export/exportFlow', parameter)
}

/**
 *  费控系统 删除流向
 */
export function costDelFlow (parameter) {
  return axios.formRequest.post('cost/website/flow/delFlow', parameter)
}

/**
 *  费控系统 删除流向
 */
export function costExamineFlow (parameter) {
  return axios.formRequest.post('cost/website/flow/examineFlow', parameter)
}

/**
 *  费控系统 流向结算清单列表
 */
export function costSettlementList (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/costSettlementList',
    parameter
  )
}

/**
 *  费控系统 创建流向结算清单
 */
export function createCostSettlement (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/createCostSettlement',
    parameter
  )
}

/**
 *  费控系统 修改流向结算清单
 */
export function editCostSettlement (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/editCostSettlement',
    parameter
  )
}

/**
 *  费控系统 流向结算清单详情
 */
export function costSettlementDetail (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/costSettlementDetail',
    parameter
  )
}

/**
 *  费控系统 编辑流向结算信息
 */
export function setFlowTerminalPrice (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/setFlowTerminalPrice',
    parameter
  )
}

/**
 *  费控系统 创建流向结算 数据统计
 */
export function flowSummary (parameter) {
  return axios.formRequest.post('cost/website/flow/flowSummary', parameter)
}

/**
 *  费控系统 删除流向结算清单
 */
export function delCostSettlement (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/delCostSettlement',
    parameter
  )
}

/**
 *  费控系统 提交审核流向结算清单
 */
export function examineCostSettlement (parameter) {
  return axios.formRequest.post(
    'cost/website/flow/examineCostSettlement',
    parameter
  )
}

/**
 *  费控系统 导出收款账户
 */
export function exportCollectionAccount (parameter) {
  return axios.formRequest.post(
    'cost/website/export/exportCollectionAccount',
    parameter
  )
}

/**
 *  费控系统 药品价格备案列表
 */
export function drugPriceRecordPage (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/drugPriceRecordPage',
    parameter
  )
}

/**
 *  费控系统 计算公式返回值
 */
export function execFormula (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/execFormula',
    parameter
  )
}

/**
 *  费控系统 创建药品价格备案
 */
export function createDrugPriceRecord (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/createDrugPriceRecord',
    parameter
  )
}

/**
 *  费控系统 编辑药品价格备案
 */
export function editDrugPriceRecord (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/editDrugPriceRecord',
    parameter
  )
}

/**
 *  费控系统 药品价格备案详情
 */
export function drugPriceRecordDetail (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/drugPriceRecordDetail',
    parameter
  )
}

/**
 *  费控系统 删除药品价格备案
 */
export function delDrugPriceRecord (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/delDrugPriceRecord',
    parameter
  )
}

/**
 *  费控系统 导出药品价格备案
 */
export function exportDrugPriceRecord (parameter) {
  return axios.formRequest.post(
    'cost/website/export/exportDrugPriceRecord',
    parameter
  )
}

/**
 *  费控系统 发货单列表
 */
export function invoicePage (parameter) {
  return axios.formRequest.post('cost/website/invoice/page', parameter)
}

/**
 *  费控系统 财务出纳管理列表
 */
export function cashierPage (parameter) {
  return axios.formRequest.post('cost/website/cashier/page', parameter)
}

/**
 *  费控系统 财务出纳管理详情
 */
export function cashierDetail (parameter) {
  return axios.formRequest.post('cost/website/cashier/detail', parameter)
}

/**
 *  费控系统  财务出纳管理 填写付款信息
 */
export function cashierAddCashierLog (parameter) {
  return axios.formRequest.post('cost/website/cashier/addCashierLog', parameter)
}

/**
 *  费控系统  财务出纳管理 导出单据打印
 */
export function exportCashierLog (parameter) {
  return axios.formRequest.post(
    'cost/website/export/exportCashierLog',
    parameter
  )
}

/**
 *  费控系统  财务出纳管理 删除单据信息
 */
export function delCashierLog (parameter) {
  return axios.formRequest.post('cost/website/cashier/delCashierLog', parameter)
}

/**
 *  费控系统  付款账户列表
 */
export function paymentBankList (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/paymentBankList',
    parameter
  )
}

/**
 *  费控系统  创建付款账户
 */
export function createPaymentBank (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/createPaymentBank',
    parameter
  )
}

/**
 *  费控系统  编辑付款账户
 */
export function editPaymentBank (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/editPaymentBank',
    parameter
  )
}

/**
 *  费控系统  付款账户更新状态
 */
export function updateStatus (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/updateStatus',
    parameter
  )
}

/**
 *  费控系统 创建发货单
 */
export function createInvoice (parameter) {
  return axios.formRequest.post('cost/website/invoice/createInvoice', parameter)
}

/**
 *  费控系统 计算单价
 */
export function computePirce (parameter) {
  return axios.formRequest.post('cost/website/invoice/computePirce', parameter)
}

/**
 *  费控系统 计算金额
 */
export function computeMoney (parameter) {
  return axios.formRequest.post('cost/website/invoice/computeMoney', parameter)
}

/**
 *  费控系统 获取药品价格备案
 */
export function getDrugPriceRecord (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/getDrugPriceRecord',
    parameter
  )
}

/**
 *  设置共坑
 */
export function jurisdictionSetPit (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/jurisdiction/setPit',
    parameter
  )
}

/**
 *  档案别名库   其他被映射客户名称
 */
export function getAliasNameByClientId (parameter) {
  return axios.formRequest.post(
    'flow/website/client_alias/getAliasNameByClientId',
    parameter
  )
}

/**
 *  历史审批详情
 */
export function getHistoryContrast (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getHistoryContrast',
    parameter
  )
}

/**
 *  创建审批
 */
export function AddWebOa (parameter) {
  return axios.formRequest.post('crm/website/oa/add', parameter)
}

/**
 *  创建审批模版详情
 */
export function gettemplateDetail (parameter) {
  return axios.formRequest.post('crm/website/oa/templateDetail', parameter)
}

/**
 *  创建审批模版审批流列表
 */
export function getrealStepList (parameter) {
  return axios.formRequest.post('crm/website/oa/realStepList', parameter)
}

/**
 *  OA创建实时刷新审批流程
 */
export function refreshStepList (parameter) {
  return axios.formRequest.post('crm/website/oa/refreshStepList', parameter)
}

/**
 *  创建审批模版选择档案
 */
export function getClientList (parameter) {
  return axios.formRequest.post('crm/website/visit/getClientList', parameter)
}

/**
 *  锁定地址
 */
export function lockAddressSet (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/client/lockAddressSet',
    parameter
  )
}

/**
 *  创建审批获取关联oa审批列表
 */
export function getFlowDetailPage (parameter) {
  return axios.formRequest.post('crm/website/oa/flowDetailPage', parameter)
}

/**
 *  创建oa审批获取审批人列表
 */
export function getquarterList (parameter) {
  return axios.formRequest.post('crm/website/oa/quarterList', parameter)
}

/**
 *  撤回创建oa审批
 */
export function RevokeOa (parameter) {
  return axios.formRequest.post('crm/website/oa/revoke', parameter)
}

/**
 *  获取工作日天数
 */
export function getWorkDay (parameter) {
  return axios.formRequest.post('crm/website/oa/getWorkDay', parameter)
}

/**
 *  oa获取涉及产品分类
 */
export function getGoodsCategories (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsCategories',
    parameter
  )
}

/**
 *  离职人员周报 人员接口
 */
export function cancelWeekReportList (parameter) {
  return axios.formRequest.post(
    '/crm/website/report/cancelWeekReportList',
    parameter
  )
}

/**
 *  费控系统 计算折扣率
 */
export function computeRate (parameter) {
  return axios.formRequest.post('cost/website/invoice/computeRate', parameter)
}

/**
 *  费控系统 发货单详情
 */
export function invoiceDetail (parameter) {
  return axios.formRequest.post('cost/website/invoice/detail', parameter)
}

/**
 *  费控系统 删除发货单
 */
export function delInvoice (parameter) {
  return axios.formRequest.post('cost/website/invoice/delInvoice', parameter)
}

/**
 *  费控系统 编辑发货单
 */
export function editInvoice (parameter) {
  return axios.formRequest.post('cost/website/invoice/editInvoice', parameter)
}

/**
 *  费控系统 提交审核发货单
 */
export function submitExamineInvoice (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/submitExamineInvoice',
    parameter
  )
}

/**
 *  费控系统 撤销审核发货单
 */
export function revokeExamineInvoice (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/revokeExamineInvoice',
    parameter
  )
}

/**
 *  费控系统 添加付款信息
 */
export function addPaymentLog (parameter) {
  return axios.formRequest.post('cost/website/invoice/addPaymentLog', parameter)
}

/**
 *  费控系统 删除付款信息
 */
export function delPaymentLog (parameter) {
  return axios.formRequest.post('cost/website/invoice/delPaymentLog', parameter)
}

/**
 *  费控系统 删除付款信息
 */
export function examineInvoice (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/examineInvoice',
    parameter
  )
}

/**
 *  费控系统 服务商结算清单提交审核
 */
export function submitServerExamineInvoice (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/submitServerExamineInvoice',
    parameter
  )
}

/**
 *  费控系统 服务商结算清单撤销审核
 */
export function revokeServerExamineInvoice (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/revokeServerExamineInvoice',
    parameter
  )
}

/**
 *  费控系统 添加结算信息
 */
export function addSettlementLog (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/addSettlementLog',
    parameter
  )
}

/**
 *  费控系统 删除结算信息
 */
export function delSettlementLog (parameter) {
  return axios.formRequest.post(
    'cost/website/invoice/delSettlementLog',
    parameter
  )
}

/**
 *  费控系统 获取客户账户
 */
export function getCollectionById (parameter) {
  return axios.formRequest.post(
    'cost/website/collection/getCollectionById',
    parameter
  )
}

/**
 *  费控系统 发货单 导出
 */
export function exportInvoice (parameter) {
  return axios.formRequest.post('cost/website/export/exportInvoice', parameter)
}

/**
 *  APP追加绑定次数设置 详情
 */
export function bindAppQuarterDetail (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/quarter/bindAppQuarterDetail',
    parameter
  )
}

/**
 *  下属岗位列表
 */
export function lowerList (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/quarter/lowerList',
    parameter
  )
}

/**
 *  下属岗位列表
 */
export function bindAppQuarter (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/quarter/bindAppQuarter',
    parameter
  )
}

/**
 *  创建oa审批选择联系人
 */
export function getChooseContact (parameter) {
  return axios.formRequest.post('crm/website/visit/chooseContact', parameter)
}

/**
 *  创建oa审批选择医生
 */
export function getDoctorList (parameter) {
  return axios.formRequest.post('crm/website/visit/doctorList', parameter)
}

/**
 *  埋点
 */
export function clickBuryingPoint (parameter) {
  return axios.formRequest.post('masterdata/website/check/click', parameter)
}

/**
 *  保存考核层级设置
 */
export function levelEditor (parameter) {
  return axios.formRequest.post('crm/website/Setting/levelEditor', parameter)
}

/**
 *  某项考核方案详情列表
 */
export function assessList (parameter) {
  return axios.formRequest.post('crm/website/assess_item/assessList', parameter)
}

/**
 *  所有考核项
 */
export function allList (parameter) {
  return axios.formRequest.post('crm/website/assess_item/allList', parameter)
}

/**
 *  设置考核项
 */
export function assessItemSettingAll (parameter) {
  return axios.formRequest.post('crm/website/assess_item/settingAll', parameter)
}

/**
 *  某考核项历史考核标准
 */
export function assessItemList (parameter) {
  return axios.formRequest.post(
    'crm/website/assess_item/assessItemList',
    parameter
  )
}

/*
 * 设置某个考核项
 * */
export function assessItemSetting (parameter) {
  return axios.formRequest.post('crm/website/assess_item/setting', parameter)
}

/*
 * 设置某个考核项
 * */
export function pageShowItem (parameter) {
  return axios.formRequest.post(
    'crm/website/assess_item/pageShowItem',
    parameter
  )
}

/*
 * 获取当前是招商还是自营
 * */
export function getPeriodType (parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/getPeriodType',
    parameter
  )
}

/**
 *  别名操作日志
 */
export function operateLogPage (parameter) {
  return axios.formRequest.post(
    'flow/website/client_alias/operateLogPage',
    parameter
  )
}

/**
 *  档案停用|启用
 */
export function stopClient (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/stopClient',
    parameter
  )
}

/**
 *  导出档案停用模版
 */
export function exportStopClientTemplateAsyn (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportStopClientTemplate',
    parameter
  )
}

/**
 *  添加临时档案
 */
export function addClientTemp (parameter) {
  return axios.formRequest.post('flow/website/flow/addClientTemp', parameter)
}

/**
 *  删除临时档案
 */
export function delClientTemp (parameter) {
  return axios.formRequest.post('flow/website/flow/delClientTemp', parameter)
}

/**
 *  行业库档案调用记录
 */
export function platformMatchLogPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/platformMatchLogPage',
    parameter
  )
}

/**
 *  导出行业库档案调用记录（异步）
 */
export function exportPlatformMatchLog (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportPlatformMatchLog',
    parameter
  )
}

// 自报数据按产品列表

export function getReportGoodsList (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportGoodsList',
    parameter
  )
}

// 自报数据按产品全年数据

export function getReportGoodsYear (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportGoodsYear',
    parameter
  )
}

// 自报数据按部门数据列表
export function getReportDepartmentList (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportDepartmentList',
    parameter
  )
}

// 自报数据按部门全年数据
export function getReportDepartmentYear (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportDepartmentYear',
    parameter
  )
}

// 自报数据按岗位数据列表
export function getReportQuarterList (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportQuarterList',
    parameter
  )
}

// 自报数据按岗位全年数据
export function getReportQuarterYear (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/reportQuarterYear',
    parameter
  )
}

// 档案别名数据
export function getclientTabList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_alias/clientTabList',
    parameter
  )
}

// 档案流向映射模板列表
export function flowTemplateClientPage (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/flowTemplateClientPage',
    parameter
  )
}

// 档案流向映射模板详情
export function flowTemplateClientDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/flowTemplateClientDetail',
    parameter
  )
}

// 设置档案流向映射模板
export function setClientFlowTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setClientFlowTemplate',
    parameter
  )
}

// 产品匹配设置列表
export function goodsMatchPage (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/goodsMatchPage',
    parameter
  )
}

// 设置产品匹配
export function setGoodsMatch (parameter) {
  return axios.formRequest.post('flow/website/setting/setGoodsMatch', parameter)
}
// 产品匹配删除
export function delGoodsMatch (parameter) {
  return axios.formRequest.post('flow/website/setting/delGoodsMatch', parameter)
}

// 代表kpi报表
export function kpiList (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/kpiList',
    parameter
  )
}

// 代表kpi报表
export function exportKpiList (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/exportKpiList',
    parameter
  )
}

// 代表kpi报表
export function getDetailPage (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/getDetailPage',
    parameter
  )
}

// 代表kpi报表
export function exportDetailPage (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_statement_activity/exportDetailPage',
    parameter
  )
}

/**
 *  康恩贝产品价格体系列表
 */
export function knbPriceMapPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_configuration/knbPriceMapPage',
    parameter
  )
}

/**
 *  获取康恩贝筛选
 */
export function getKnbFieldList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_configuration/getKnbFieldList',
    parameter
  )
}

/**
 *  导出康恩贝产品价格体系（异步）
 */
export function exportKnbPriceMap (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportKnbPriceMap',
    parameter
  )
}

/**
 *  导出康恩贝产品价格体系（异步）
 */
export function knbPriceMapDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_configuration/knbPriceMapDetail',
    parameter
  )
}

/**
 *  纯销明细表
 */
export function knbFlowPage (parameter) {
  return axios.formRequest.post('flow/website/flow/knbFlowPage', parameter)
}

/**
 * 康恩贝获取备份月份
 *
 */
export function historMonthBak (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/historMonthBak',
    parameter
  )
}

/**
 * 康恩贝获取备份日志列表
 *
 */
export function bakLogPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/bakLogPage',
    parameter
  )
}

/**
 * 康恩贝流向历史数据导出
 *
 */
export function exportFlowBak (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportFlowBak',
    parameter
  )
}

/**
 * 康恩贝流向历史数据导出
 *
 */
export function exportClientBak (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportClientBak',
    parameter
  )
}

/**
 * 康恩贝产品历史数据导出
 *
 */
export function exportGoodsBak (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportGoodsBak',
    parameter
  )
}

/**
 * 连锁总部列表接口
 *
 */
export function brandChainList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/brandChainList',
    parameter
  )
}

/**
 *  芒哥 历史关联关系 获取导出月份
 */
export function getBakMonth (parameter) {
  return axios.formRequest.post('mango/website/setting/getBakMonth', parameter)
}

/**
 *  芒哥 历史关联关系 导出历史关联关系
 */
export function exportMgRelationBak (parameter) {
  return axios.formRequest.post(
    'mango/website/export/exportMgRelationBak',
    parameter
  )
}

/**
 *  费控系统 获取终端三者关系人员列表
 */
export function getQuarterList (parameter) {
  return axios.formRequest.post(
    'cost/website/terminal_price/getQuarterList',
    parameter
  )
}

/**
 *  导出终端指标分配
 */
export function exportSaleIndexByClient (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportSaleIndexByClient',
    parameter
  )
}

/**
 *  导出终端指标分配
 */
export function crmAgreementTemplateList (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/templateList',
    parameter
  )
}

/**
 *  协议模板其他设置
 */
export function otherAgreementSetting (parameter) {
  return axios.formRequest.post(
    'crm/website/template/otherAgreementSetting',
    parameter
  )
}

/**
 * 导出康恩贝纯销汇总表
 *
 */
export function exportPureSummary (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportPureSummary',
    parameter
  )
}

/**
 * 康恩贝扣减项明细列表
 *
 */
export function deductionPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/knb_relation/deductionPage',
    parameter
  )
}

/**
 * 导出康恩贝扣减项明细
 *
 */
export function exportKnbDeduction (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportKnbDeduction',
    parameter
  )
}

/**
 * 经销存汇总列表
 *
 */
export function knbFlowDistributionPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbFlowDistributionPage',
    parameter
  )
}

/**
 * 经销存汇总列表
 *
 */
export function exportFlowDistribution (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportFlowDistribution',
    parameter
  )
}

/**
 * 客户纯销汇总列表
 *
 */
export function knbClientFlowPurePinPage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbClientFlowPurePinPage',
    parameter
  )
}

/**
 * 导出客户纯销汇总
 *
 */
export function exportClientFlowPurePin (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportClientFlowPurePin',
    parameter
  )
}

/**
 * 服务商纯销汇总列表
 *
 */
export function knbServerClientPurePage (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/knbServerClientPurePage',
    parameter
  )
}

/**
 * 服务商纯销汇总列表
 *
 */
export function exportServerClientPure (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportServerClientPure',
    parameter
  )
}

/**
 *  新增协议
 */
export function addAgreement (parameter) {
  return axios.formRequest.post('crm/website/template/addAgreement', parameter)
}

/**
 *  协议添加
 */
export function addCrmAgreement (parameter) {
  return axios.formRequest.post('crm/website/crm_agreement/add', parameter)
}

/**
 *  协议列表
 */
export function pageCrmAgreement (parameter) {
  return axios.formRequest.post('crm/website/crm_agreement/page', parameter)
}

/**
 *  协议状态
 */
export function getAgreementStatus (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/agreementStatus',
    parameter
  )
}

/**
 *  协议详情
 */
export function crmAgreementDetail (parameter) {
  return axios.formRequest.post('crm/website/crm_agreement/detail', parameter)
}

/**
 *  协议 购进渠道
 */
export function buyChannelList (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/buyChannelList',
    parameter
  )
}

/**
 *  协议 导出
 */
export function exportCrmAgreement (parameter) {
  return axios.formRequest.post('crm/website/crm_agreement/export', parameter)
}

/**
 *  购销合同购货单位列表（新）
 */
export function clientListCrmAgreement (parameter = {}) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/clientList',
    parameter
  )
}

/**
 *  购销合同采购产品（新）
 */
export function goodsListCrmAgreement (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/goodsList',
    parameter
  )
}

/**
 *  购销合同采购产品（新）
 */
export function updateFieldCrmAgreement (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/updateField',
    parameter
  )
}

/**
 *  获取协议module_int
 */
export function haveModuleIntCrmAgreement (parameter) {
  return axios.formRequest.post(
    'crm/website/crm_agreement/haveModuleInt',
    parameter
  )
}

/**
 *  根据文件名称获取档案详情
 */
export function getFileClientRow (parameter) {
  return axios.formRequest.post(
    'flow/website/import/getFileClientRow',
    parameter
  )
}

/**
 *  流向数据查询配置
 */
export function FlowtitleSortList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortList',
    parameter
  )
}

/**
 *  流向数据查询配置（新）
 */
export function FlowtitleSortList2 (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_title_sort/FlowtitleSortList',
    parameter
  )
}

/**
 *  绩效奖金明细表列表接口
 */
export function performanceBonuses (parameter) {
  return axios.formRequest.post('flow/website/bonus/page', parameter)
}

/**
 *  医生估量设置列表
 */
export function GetDoctorValueSettingList (parameter) {
  return axios.formRequest.post(
    'crm/website/doctor_value/settingList',
    parameter
  )
}

/**
 *  医生估量设置保存
 */
export function DoctorValueSetting (parameter) {
  return axios.formRequest.post('crm/website/doctor_value/setting', parameter)
}

/**
 *  公共配置接口
 */
export function setGlobalConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/setGlobalConfig',
    parameter
  )
}

/**
 *  设置备份档案权限配置
 */
export function getClientHistoryConfig (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/getClientHistoryConfig',
    parameter
  )
}

/**
 *  设置备份档案权限配置
 */
export function setClientHistory (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/setClientHistory',
    parameter
  )
}

/**
 *  删除指标的档案列表
 */
export function delIndexClientPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/delIndexClientPage',
    parameter
  )
}
/**
 *  删除指标的档案列表（新）
 */
export function getQuarterListByIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_quarter_index/getQuarterListByIndex',
    parameter
  )
}
/**
 *  删除指标的岗位列表（新）
 */
export function getClientListByIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_client_index/getClientListByIndex',
    parameter
  )
}

/**
 *   删除指标接口
 */
export function delSaleindex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/delIndex',
    parameter
  )
}

/**
 *   删除指标接口（新）
 */
export function delQuarterIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_quarter_index/delQuarterIndex',
    parameter
  )
}

/**
 *   删除指标接口（新）
 */
export function delClientIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_client_index/delClientIndex',
    parameter
  )
}
/**
 *   删除指标接口
 */
export function delIndexQuarterPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/saleindex/delIndexQuarterPage',
    parameter
  )
}

/**
 *  档案编辑字段排序
 */
export function getWebClientField (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getWebClientField',
    parameter
  )
}
/**
 *  导入档案下载表头字段列表
 */
export function getClientheadList (cls) {
  return axios.formRequest.post('masterdata/website/client/headList', {
    cls
  })
}

/**
 *  导入档案保存表头字段
 */
export function saveHeadSort (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/saveHeadSort',
    parameter
  )
}
/**
 *  共岗功能配置
 */
export function shareQuarterSetting (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/setting',
    parameter
  )
}
/**
 *  编辑共岗产品
 */
export function editClientShareGoods (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/editClientShareGoods',
    parameter
  )
}
/**
 *  设置过共岗备案的产品列表
 */
export function clientShareGoods (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/clientShareGoods',
    parameter
  )
}

/**
 *  获取销售指标期间设置
 */
export function getSaleIndexTime (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/getSaleIndexTime',
    parameter
  )
}

/**
 *  设置销售指标期间设置
 */
export function setSaleIndexTime (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/setSaleIndexTime',
    parameter
  )
}

/**
 *  根据部门id获取部门负责人
 */
export function getTopQuarterRow (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/quarter/getTopQuarterRow',
    parameter
  )
}

/**
 *  部门下放指标列表
 */
export function devolveIndexPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/devolveIndexPage',
    parameter
  )
}
/**
 *  编辑分配指标
 */
export function editQuarterIndex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/editQuarterIndex',
    parameter
  )
}

/**
 *  确认并下放操作
 */
export function confirmIndex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/confirmIndex',
    parameter
  )
}

/**
 *  查看异步下放指标状态
 */
export function getIndexBatchRow (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getIndexBatchRow',
    parameter
  )
}

/**
 *  查看异步下放指标状态（新）
 */
export function getManualBatch (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getManualBatch',
    parameter
  )
}

/**
 *  部门产品指标汇总
 */
export function goodsTotal (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/goodsTotal',
    parameter
  )
}

/**
 *  终端指标下放列表
 */
export function devolveIndexClientPage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/devolveIndexClientPage',
    parameter
  )
}

/**
 *  编辑终端指标调整值
 */
export function editClientIndex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/editClientIndex',
    parameter
  )
}

/**
 *  获取初始指标确认
 */
export function getFirstCheck (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getFirstCheck',
    parameter
  )
}

/**
 *  初始指标确认
 */
export function firstCheckClientIndex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/firstCheckClientIndex',
    parameter
  )
}

/**
 *  确认指标
 */
export function checkClientIndex (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/checkClientIndex',
    parameter
  )
}

/**
 *  确认指标
 */
export function getNowPeriod (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getNowPeriod',
    parameter
  )
}

/**
 *  导出下放档案指标
 */
export function exportDevolveIndexClient (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportDevolveIndexClient',
    parameter
  )
}

/**
 *  导出下放档案指标
 */
export function exportDevolveIndexQuarter (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportDevolveIndexQuarter',
    parameter
  )
}

/**
 *  创建编辑指标规则
 */
export function setRule (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/setRule',
    parameter
  )
}

/**
 *  获取指标规则列表
 */
export function rulePage (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/rulePage',
    parameter
  )
}

/**
 *  获取指标规则详情
 */
export function ruleDetail (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/ruleDetail',
    parameter
  )
}

/**
 * 按档案统计销售指标列表(新)
 */
export function newSaleindexSaleIndexByClientList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/new_saleindex/saleIndexByClientList',
    parameter
  )
}

/**
 * 按部门统计销售指标列表(新)
 */
export function newSaleindexSalesIndexByDepartmentList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/new_saleindex/salesIndexByDepartmentList',
    parameter
  )
}

/**
 * 按岗位统计销售指标列表(新)
 */
export function newSaleindexSalesIndexByQuarterList (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/new_saleindex/salesIndexByQuarterList',
    parameter
  )
}

/**
 * 清空指标
 */
export function delAllIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/setting/delAllIndex',
    parameter
  )
}

/**
 * 档案导入日志详情
 */
export function importClientLogRow (parameter) {
  return axios.formRequest.post(
    '/masterdata/website/client/importClientLogRow',
    parameter
  )
}

/**
 *  档案字段编辑（设置职称）
 */
export function setDoctorTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setDoctorTitle',
    parameter
  )
}

/**
 *  档案字段编辑（设置职位）
 */
export function setDoctorPosition (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setDoctorPosition',
    parameter
  )
}

/**
 *  获取FlowNum
 */
export function getLoginFlowNum (parameter) {
  return axios.formRequest.post('flow/website/flow/getLoginFlowNum', parameter)
}

/**
 *  微信扫码登录
 */
export function getWeiXinScan (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/wei_xin/wxScan',
    parameter
  )
}

/**
 *  绑定企业确认短信
 */
export function SureconfirmSms (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/wei_xin/confirmSms',
    parameter
  )
}

/**
 *  绑定微信
 */
export function bindWinXin (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/wei_xin/bindWinXin',
    parameter
  )
}
/**
 *  清空三者关系
 */
export function ResetRrelationship (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/delThreeRelation',
    parameter
  )
}

/**
 *  导出调整值
 */
export function exportDevolveIndexClientTempLate (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/exportDevolveIndexClientTempLate',
    parameter
  )
}

/**
 * 获取指标调整
 */
export function getNowYearMonth (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/new_saleindex/getNowYearMonth',
    parameter
  )
}

/**
 *  采集进度档案列表
 */
export function collectClientPage (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/collectClientPage',
    parameter
  )
}

/**
 *  商业采集进度，批量流转异步模版下载
 */
export function synCollectClientDownload (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/synCollectClientDownload',
    parameter
  )
}

/**
 *  获取采集进度批次
 */
export function getBatchList (parameter) {
  return axios.formRequest.post('flow/website/collect/getBatchList', parameter)
}

/**
 *  获取采集进度汇总
 */
export function getCollectTotal (parameter) {
  return axios.formRequest.post('flow/website/collect/getCollectTotal', parameter)
}

/**
 *  创建采集进度档案
 */
export function createCollectClient (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/createCollectClient',
    parameter
  )
}

/**
 *  采集进度档案详情
 */
export function collectClientDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/collectClientDetail',
    parameter
  )
}

/**
 *  采集进度操作状态
 */
export function createCollectClientLog (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/createCollectClientLog',
    parameter
  )
}
/**
 *  采集基础信息更新
 */
export function updateCollectClientBasic (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/updateCollectClientBasic',
    parameter
  )
}

/**
 *  取消采集商业
 */
export function cancelCollectClient (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/cancelCollectClient',
    parameter
  )
}

/**
 *  删除采集商业
 */
export function delCollectClient (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/delCollectClient',
    parameter
  )
}

/**
 *  异步导出商业采集模板
 */
export function exportCollectTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportCollectTemplate',
    parameter
  )
}

/**
 *  采集进度操作状态
 */
export function collectStatusList (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/collectStatusList',
    parameter
  )
}

/**
 *  采集进度 添加操作日志
 */
export function createOperationLog (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/createCollectOpetionLog',
    parameter
  )
}

/**
 *  网抓账号列表
 */
export function newWebscrapAccountList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/newWebscrapAccountList',
    parameter
  )
}

/**
 *  获取账号密码详情（新）
 */
export function getNewWebscrapPassword (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getNewWebscrapPassword',
    parameter
  )
}

/**
 *  保存账号密码（新）
 */
export function setNewWebscrapAccount (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setNewWebscrapAccount',
    parameter
  )
}

/**
 *  保存网址（新）
 */
export function setWebscrapAddress (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setWebscrapAddress',
    parameter
  )
}

/**
 *  检测流向锁定数据
 */
export function checkFlowLockData () {
  return axios.formRequest.post('flow/website/flow/checkFlowLockData', {})
}

/**
 *  主数据（筛选）（快克）
 */
export function quickScreenList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/quickScreenList',
    parameter
  )
}

/**
 *  表头列表（快克）
 */
export function quickTitleList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/quickTitleList',
    parameter
  )
}

/**
 *  快克档案主数据（快克）
 */
export function quickClientPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/quickClientPage',
    parameter
  )
}

/**
 *  快克档案主数据（快克） 表头设置
 */
export function setQuickTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/setQuickTitle',
    parameter
  )
}

/**
 *  快克档案主数据（快克） 导出
 */
export function exportQuickList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/exportQuickList',
    parameter
  )
}

/**
 *  保存表头建立别名
 */
export function saveTitleAlias (parameter) {
  return axios.formRequest.post('flow/website/import/saveTitleAlias', parameter)
}

/**
 *  保存表头建立别名==>多家供应商
 */
export function setTemplateAliasMult (parameter) {
  return axios.formRequest.post(
    'flow/website/import/setTemplateAliasMult',
    parameter
  )
}

/**
 *  模板字段关联设置 保存规则
 */
export function setRuleTemplate (parameter) {
  return axios.formRequest.post('crm/website/template/setRule', parameter)
}

/**
 *  模板字段关联设置 规则详情
 */
export function ruleDetailTemplate (parameter) {
  return axios.formRequest.post('crm/website/template/ruleDetail', parameter)
}

/**
 *  模板字段关联设置 oa创建规则
 */
export function ruleDetailOA (parameter) {
  return axios.formRequest.post('crm/website/oa/ruleDetail', parameter)
}

/**
 *  销售异常数据统计列表
 */
export function abnormalPurchase (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/abnormalPurchase',
    parameter
  )
}

/**
 *  销售异常数据导出
 */
export function exportAbnormalPurchase (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportAbnormalPurchase',
    parameter
  )
}

/**
 *  调整指标 (部门无涉及产品，无需下放产品指标)
 */
export function checkQuarterGoods (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/checkQuarterGoods',
    parameter
  )
}

/**
 *  保存网址（新）
 */
export function editBatch (parameter) {
  return axios.formRequest.post('flow/website/collect/editBatch', parameter)
}
/**
 *  流向清洗省市区自定义字段
 */
export function getCustomSsq (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getCustomSsq',
    parameter
  )
}

/**
 *  流向清洗档案名称的省市区（第三方接口）
 */
export function getSsqByText (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getSsqByText',
    parameter
  )
}

/**
 *  康恩贝主数据列表
 */
export function knbClientPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/knbClientPage',
    parameter
  )
}

/**
 *  获取康恩贝导出表头
 */
export function getKnbTitleList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/getKnbTitleList',
    parameter
  )
}

/**
 *  设置康恩贝导出表头
 */
export function setKnbTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/setKnbTitle',
    parameter
  )
}

/**
 *  获取康恩贝导出表头
 */
export function exportKnbClientPage (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportKnbClientPage',
    parameter
  )
}

/**
 *  获取康恩贝导出表头
 */
export function exportOriginalUploadLog (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/exportOriginalUploadLog',
    parameter
  )
}

/**
 *  通过枚举类名获取对应的枚举列表（新）
 */
export function getEnumList (parameter) {
  return axios.formRequest.post(
    'enums/website/enum_business/getEnumList',
    parameter
  )
}

/**
 *  保存指标分配方案配置（新）
 */
export function saveConfig (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/index_allocation_config/saveConfig',
    parameter
  )
}

/**
 *  根据类型获取最新指标分配方案（新）
 */
export function getLastConfig (parameter) {
  return axios.formRequest.get(
    `/jurisdiction/website/index_allocation_config/getLastConfig?type=${parameter}`
  )
}

/**
 *  岗位分配指标模板下载（新）
 */
export function downloadQuarterIndexTpl (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/export/downloadQuarterIndexTpl',
    parameter
  )
}
/**
 *  指标进度导出 岗位
 */
export function exportQuarterListIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_quarter_index/exportList',
    parameter
  )
}
/**
 *  指标进度导出 终端
 */
export function exportClientListIndex (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/sale_client_index/exportList',
    parameter
  )
}

/**
 *  档案分配指标模板下载（新）
 */
export function downloadClientIndexTpl (parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/export/downloadClientIndexTpl',
    parameter
  )
}

/**
 *  档案曾用名维护（模板下载）
 */
export function exportAysnFormerName (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportAysnFormerName',
    parameter
  )
}

/**
 *  档案维护配置列表
 */
export function clientNameList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/clientNameList',
    parameter
  )
}

/**
 *  档案维护配置
 */
export function setClientName (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/setClientName',
    parameter
  )
}

/**
 *  档案维护配置
 */
export function clientNameRule (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/clientNameRule',
    parameter
  )
}

/**
 *  批量匹配
 */
export function clientMatch (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_match/match',
    parameter
  )
}
/**
 *  协议产品政策低价和标准开票价
 */
export function agreementPrice (parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods_configuration/agreementPrice',
    parameter
  )
}
/**
 *  康恩贝关联关系删除
 */
export function del (parameter) {
  return axios.formRequest.post(
    'masterdata/website/knb_relation/del',
    parameter
  )
}
/**
 *  康恩贝关联关系保存
 */
export function knbKelationAdd (parameter) {
  return axios.formRequest.post(
    'masterdata/website/knb_relation/save',
    parameter
  )
}
/**
 *  康恩贝关联关系详情
 */
export function knbKelationDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/knb_relation/detail',
    parameter
  )
}

/**
 *  商业采集 导出接口
 */
export function collectExport (parameter) {
  return axios.formRequest.post('flow/website/collect/export', parameter)
}
/**
 *  手动执行跑批操作
 */
export function saveManualBatch () {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/saveManualBatch'
  )
}
/**
 *  流向进货量和差异值的显示隐藏
 */
export function getReportShow (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/getReportShow',
    parameter
  )
}

/**
 *  自报填写产品配置
 */
export function goodsSetting (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/goodsSetting',
    parameter
  )
}
/**
 *  上传记录 下载文件
 */
export function exportUploadLogDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/exportUploadLogDetail',
    parameter
  )
}

/**
 *  自报填写产品配置详情
 */
export function goodsSettingDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/goodsSettingDetail',
    parameter
  )
}

/**
 *  自报统计导出
 */
export function exportFillStage (parameter) {
  return axios.formRequest.post(
    'crm/website/self_report/exportFillStage',
    parameter
  )
}
/**
 *  产品别名导出
 */
export function goodsAliasExport (parameter) {
  return axios.formRequest.post('flow/website/goods_alias/export', parameter)
}
/**
 *  档案别名导出
 */
export function clientAliasExport (parameter) {
  return axios.formRequest.post('flow/website/client_alias/export', parameter)
}

/**
 * 更新医生信息模板下载
 */
export function updateDoctorGoods (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/updateDoctorGoods',
    parameter
  )
}

/**
 * 更新医生负责人(无涉及产品)
 */
export function updateDoctorQuarter (parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/updateDoctorQuarter',
    parameter
  )
}

/**
 *  主规格转换列表
 */
export function specTransformList (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/specTransformList',
    parameter
  )
}

/**
 *  主规格转换保存
 */
export function saveSpecTransform (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/saveSpecTransform',
    parameter
  )
}

/**
 *  主规格转换删除
 */
export function deLSpecTransform (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/deLSpecTransform',
    parameter
  )
}

/**
 *  获取网抓账号列表
 */
export function getWebscrapAccountList2 (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getWebscrapAccountList2',
    parameter
  )
}

/**
 *  编辑自定义字段
 */
export function editFlowField (parameter) {
  return axios.formRequest.post('flow/website/flow/editFlowField', parameter)
}

/**
 *  指标类型获取
 */
export function getIndexTypeSet (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/getIndexTypeSet',
    parameter
  )
}

/**
 *  指标类型设置
 */
export function indexTypeSet (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/indexTypeSet',
    parameter
  )
}

/**
 *  修改类型字段
 */
export function changeClientType (parameter) {
  return axios.formRequest.post(
    'masterdata/website/check/changeClientType',
    parameter
  )
}

/**

/**
 *  获取网抓账号详情
 */
export function getAccountInfo (webscrap_account_id) {
  return axios.formRequest.post('masterdata/website/client/getAccountInfo', {
    webscrap_account_id
  })
}

export function getScrapCycleConfig (parameter) {
  return axios.formRequest.post(
    'flow/website/setting/scrapCycleConfig',
    parameter
  )
}
/**
 *  商务订单导出
 */
export function exportOrder (parameter) {
  return axios.formRequest.post('order/website/order/export', parameter)
}

/**
 *  盘龙创建编辑商务订单前调用
 */
export function isOverSize (parameter) {
  return axios.formRequest.post('order/website/order/overSize', parameter)
}

/**
 *  销售阶段
 */
export function getAccountStagePage (parameter) {
  return axios.formRequest.post('crm/website/visit/accountStagePage', parameter)
}
/**
 *  修改订单采购数量
 */
export function editGoodsUnitCount (parameter) {
  return axios.formRequest.post(
    'order/website/order/editGoodsUnitCount',
    parameter
  )
}

/**
 *  跑批
 */
export function RunjooyumStatistics (parameter) {
  return axios.formRequest.post('crm/website/visit/jooyumStatistics', parameter)
}

/**
 *  销售阶段详情
 */
export function getAccountStageDetail (parameter) {
  return axios.formRequest.post(
    'crm/website/visit/accountStageDetail',
    parameter
  )
}

/**
 * 获取采集问题类型列表
 * @returns
 */
export function getCollectList (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/getCollectList',
    parameter
  )
}
/**
 *  编辑销售阶段
 */
export function editVisit (parameter) {
  return axios.formRequest.post('crm/website/visit/editVisit', parameter)
}

/**
 *  获取更新日志
 */
export function getBatchLog (type) {
  return axios.formRequest.post('masterdata/website/knb_relation/getBatchLog', {
    type
  })
}
/**
 * 添加问题
 * @returns
 */
export function subQusetion (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/add',
    parameter
  )
}

/**
 * 排查处理详情
 * @returns
 */
export function subSequenThandleDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/handleDetail',
    parameter
  )
}

/**
 * 排查处理提交
 * @returns
 */
export function subSequenThandle (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/handle',
    parameter
  )
}

/**
 * 采集问题处理 导出
 * @returns
 */
export function subSequenThandleExport (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/exportSubsequent',
    parameter
  )
}

/**
 * 采集问题处理 导出排查详情
 * @returns
 */
export function exportSubsequentLog (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/exportSubsequentLog',
    parameter
  )
}

/**
 * 查看处理进度详情
 * @returns
 */
export function scheduleDetail (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/scheduleDetail',
    parameter
  )
}

/**
 * 查看处理进度详情
 * @returns
 */
export function exportSubsequent (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/exportSubsequent',
    parameter
  )
}

/**
 * 查看处理进度详情 查看更多
 * @returns
 */
export function subsequentLogPage (parameter) {
  return axios.formRequest.post(
    'flow/website/collect_subsequent/logPage',
    parameter
  )
}

/**
 * 岗位编辑配置
 * @returns
 */
export function editQuarterSetting (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/editQuarterSetting',
    parameter
  )
}

/**
 * 商业返利申请列表
 * @returns
 */
export function getApplyList (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/getApplyList',
    parameter
  )
}

/**
 * 发起商业返利申请列表
 * @returns
 */
export function getCommerceRebateApplyList (parameter) {
  return axios.formRequest.post(
    'cost/website/fee_settlement_budget/getCommerceRebateApplyList',
    parameter
  )
}

/**
 * 商业返利编辑 商业返利梳理列表
 * @returns
 */
export function getApplyFlowList (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/getApplyFlowList',
    parameter
  )
}

/**
 * 商业返利编辑 确认结算申请
 * @returns
 */
export function saveApply (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/saveApply',
    parameter
  )
}

/**
 * 商业返利编辑 商业返利申请详情
 * @returns
 */
export function getApplyDetail (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/getApplyDetail',
    parameter
  )
}

/**
 * 商业返利编辑 批量提交审核
 * @returns
 */
export function multipleSubmitAudit (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/multipleSubmitAudit',
    parameter
  )
}

/**
 * 商业返利编辑 批量删除审核
 * @returns
 */
export function multipleDelete (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/multipleDelete',
    parameter
  )
}

/**
 * 商业返利编辑 批量审核
 * @returns
 */
export function commerceMultipleAudit (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/multipleAudit',
    parameter
  )
}

/**
 * 商业返利申请统计
 * @returns
 */
export function getApplyPageSummary (parameter) {
  return axios.formRequest.post(
    'cost/website/commerce_rebate_apply/getApplyPageSummary',
    parameter
  )
}

/**
 * 费用计提预算表
 * @returns
 */
export function getBudgetList (parameter) {
  return axios.formRequest.post(
    'cost/website/fee_settlement_budget/getBudgetList',
    parameter
  )
}

/**
 * 费用计提预算数据汇总
 * @returns
 */
export function getBudgetSummary (parameter) {
  return axios.formRequest.post(
    'cost/website/fee_settlement_budget/getBudgetSummary',
    parameter
  )
}

/**
 * 费用计提预算 批量审核
 * @returns
 */
export function multipleAudit (parameter) {
  return axios.formRequest.post(
    'cost/website/fee_settlement_budget/multipleAudit',
    parameter
  )
}
/**
 * 费用计提预算 重新计算费用
 * @returns
 */
export function reCalculateFee (parameter) {
  return axios.formRequest.post(
    'cost/website/fee_settlement_budget/reCalculateFee',
    parameter
  )
}

/**
 * 费用拨付表列表
 * @returns
 */
export function getFeeAllocationList (parameter) {
  return axios.formRequest.post(
    'cost/website/sales_need_fee_allocation/getFeeAllocationList',
    parameter
  )
}

/**
 *
 * @returns
 */
export function salesPayDownloadTemplate (parameter) {
  return axios.formRequest.post('', parameter)
}

export function getHistoryList (parameter) {
  return axios.formRequest.post(
    'crm/website/visit/jooyumHistoryList',
    parameter
  )
}

// 判断档案类型有没有开启某个字段
export function getFieldByTitle (parameter) {
  return axios.formRequest.post(
    'masterdata/website/title_sort/getFieldByTitle',
    parameter
  )
}

// 是否 显示未来架构
export function getFuture (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getFuture',
    parameter
  )
}

// 指标页面的产品筛选
export function getFutureGoodsList (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/getGoodsList',
    parameter
  )
}
/**
 * 档案类型对照关系列表
 * @returns
 */
export function getPageList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_type_relation/getPageList',
    parameter
  )
}
/**
 * 档案类型对照关系详情
 * @returns
 */
export function clientTypeRelationDetail (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_type_relation/detail',
    parameter
  )
}
/**
 * 添加档案类型对照关系
 * @returns
 */
export function clientTypeRelationAdd (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_type_relation/add',
    parameter
  )
}
/**
 * 编辑档案类型对照关系
 * @returns
 */
export function clientTypeRelationEdit (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_type_relation/edit',
    parameter
  )
}
/**
 * 编辑档案类型对照关系
 * @returns
 */
export function clientTypeRelationDel (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client_type_relation/del',
    parameter
  )
}

/**
 * 编辑档案类型对照关系
 * @returns
 */
export function videoCilck (parameter) {
  return axios.formRequest.post(
    'masterdata/website/check/storageFlow',
    parameter
  )
}

/**
 * 档案级别配置页面列表
 * @returns
 */
export function clientLevelAuthConfPageList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/clientLevelAuthConfPageList',
    parameter
  )
}
/**
 * 档案级别配置页面 修改状态(停用开启删除)
 * @returns
 */
export function modifyClientLevelAuthConfStatus (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/modifyClientLevelAuthConfStatus',
    parameter
  )
}
/**
 * 获取档案字段跑批设置
 */
export function getClientMatchDataLog (parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/getClientMatchDataLog',
    parameter
  )
}

/**
 * 字段跑批设置
 */
export function synClientMatchData (parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/synClientMatchData',
    parameter
  )
}

// 商业采集进度 状态备注分页
export function getRemarkLogPageList (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/getRemarkLogPageList',
    parameter
  )
}

// 新增商业采集进度备份说明
export function addRemark (parameter) {
  return axios.formRequest.post('flow/website/collect/addRemark', parameter)
}

/**
 * 配送商库房信息上传
 */
export function webHouseImport (formData) {
  return axios.importExcel({
    method: 'post',
    url: 'order/website/house/import',
    data: formData
  })
}

/**
 * //更新等级问卷
 */
export function webHouseExport (parameter) {
  return axios.formRequest.post('order/website/house/export', parameter)
}

/**
 * //系统备份
 */
export function backups (parameter) {
  return axios.formRequest.post('masterdata/website/check/backups', parameter)
}

/**
 * //商业销售汇总数据
 */
export function censusBusinessSale (parameter) {
  return axios.formRequest.post(
    'flow/website/stats/censusBusinessSale',
    parameter
  )
}

/**
 * //商业销售汇总数据 导出
 */
export function exportCensusBusinessSale (parameter) {
  return axios.formRequest.post(
    'flow/website/export/exportCensusBusinessSale',
    parameter
  )
}

/**
 * 纯销明细表 翻页
 */
export function knbFlowPageInfo (parameter) {
  return axios.formRequest.post('flow/website/flow/knbFlowPageInfo', parameter)
}

/**
 * 批号别名库列表
 */
export function batchAliasDownloadTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/batch_alias/downloadTemplate',
    parameter
  )
}

/**
 * 批号别名库 下载模板 异步
 */
export function batchAliasDownloadTemplateAsync (parameter) {
  return axios.formRequest.post(
    'flow/website/batch_alias/downloadTemplate',
    parameter
  )
}

/**
 * 获取待处理批号数据
 */
export function getPendingBatchAlias (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/getPendingBatchAlias',
    parameter
  )
}

/**
 * 获取客户行类型
 */
export function getClientCustom (parameter) {
  return axios.formRequest.post('flow/website/flow/getClientCustom', parameter)
}

/**
 * 获得档案自定义字段选项
 */
export function getFieldTitleOptions (parameter) {
  return axios.formRequest.post(
    'masterdata/website/field/getFieldTitleOptions',
    parameter
  )
}

/**
 * 提交变更档案接口
 */
export function submitClientChangeType (parameter) {
  return axios.formRequest.post(
    'masterdata/website/import/submitClientChangeType',
    parameter
  )
}

/**
 * 批号别名库列表
 */
export function batchAliasPage (parameter) {
  return axios.formRequest.post('flow/website/batch_alias/page', parameter)
}

/**
 * 指标分配 设置季度产品
 */
export function setGoodsListByTime (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/new_saleindex/setGoodsListByTime',
    parameter
  )
}

/**
 * 商业采集进度获取
 */
export function getCollectApproval (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/getCollectApproval',
    parameter
  )
}

/**
 * 商业异常监控列表
 */
export function getAbnormalClientList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getAbnormalClientList',
    parameter
  )
}

/**
 * 获取异常数据量
 */
export function getAbnormalCompanyClientListSummary (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getAbnormalCompanyClientListSummary',
    parameter
  )
}

/**
 * 获取商业异常历史
 */
export function getSubsequentList (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/getSubsequentList',
    parameter
  )
}

/**
 * 商业采集进度获取
 */
export function editCollectSchedule (parameter) {
  return axios.formRequest.post(
    'flow/website/collect/editCollectSchedule',
    parameter,
  )
}

/**
 * 获取页面配置
 */
export function getPageConf (parameter) {
  return axios.formRequest.post(
    'crm/website/flow_sales_index_report/getPageConf',
    parameter,
  )
}

/**
 * 获取岗位列表
 */
export function getQuarterReportList (parameter) {
  return axios.formRequest.post(
    'crm/website/flow_sales_index_report/getQuarterReportList',
    parameter,
  )
}


/**
 * 获取用户列表
 */
export function getClientReportList (parameter) {
  return axios.formRequest.post(
    'crm/website/flow_sales_index_report/getClientReportList',
    parameter,
  )
}


/**
 * 下载批量更新模板接口
 */
export function downloadFujiaoFLowUpdateTemplate (parameter) {
  return axios.formRequest.post(
    'flow/website/flow/downloadFujiaoFLowUpdateTemplate',
    parameter,
  )
}



// /**
//  * 处理问题
//  */
// export function handleCompanyAbnormal (parameter) {
//   return axios.formRequest.post(
//     'flow/website/client_collect_monitor/handleCompanyAbnormal',
//     parameter,
//   )
// }



/**
 * 消息推送维护列表
 */
export function getClientMessageList (parameter) {
  return axios.formRequest.post(
    'flow/website/Client_Collect_Monitor/getClientMessageList',
    parameter,
  )
}


// /**
//  * 下载消息维护模板
//  */
// export function exportMessagePush (parameter) {
//   return axios.formRequest.post(
//     'flow/website/Client_Collect_Monitor/exportMessagePush',
//     parameter,
//   )
// }

/**
 * 获取微信群名称
 */
export function globalsetting (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/globalsetting',
    parameter,
  )
}



/**
 * 添加微信群名称
 */
export function addMessageGroup (parameter) {
  return axios.formRequest.post(
    'flow/website/Client_Collect_Monitor/addMessageGroup',
    parameter,
  )
}

/**
 * 添加/编辑推送
 */
export function addClientMessage (parameter) {
  return axios.formRequest.post(
    'flow/website/Client_Collect_Monitor/addClientMessage',
    parameter,
  )
}


/**
 * 删除推送
 */
export function delClientMessage (parameter) {
  return axios.formRequest.post(
    'flow/website/Client_Collect_Monitor/delClientMessage',
  )
}
/**
 * 删除推送
 */

export function manualAddGoodsPackageUnit (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow/manualAddGoodsPackageUnit',
    parameter,
  )
}

// /**
//  * 消息推送维护列表
//  */
// export function getClientMessageList (parameter) {
//   return axios.formRequest.post(
//     'flow/website/Client_Collect_Monitor/getClientMessageList',
//     parameter,
//   )
// }

/**
 * 下载消息维护模板
 */
export function exportMessagePush (parameter) {
  return axios.formRequest.post(
    'flow/website/Client_Collect_Monitor/exportMessagePush',
    parameter,
  )
}


/**
 * 处理问题
 */
export function handleCompanyAbnormal (parameter) {
  return axios.formRequest.post(
    'flow/website/client_collect_monitor/handleCompanyAbnormal',
    parameter,
  )
}

/**
 * 获取FTP档案列表
 */
export function getFtpClientList (parameter) {
  return axios.formRequest.post(
    'flow/website/flow_client_collect_conf/getFtpClientList',
    parameter,
  )
}

/**
 * 设置档案FTP采集配置
 */
export function setFtpClientList (parameter) {
  return axios.formRequest.post(
    '/flow/website/flow_client_collect_conf/setFtpCollectConf',
    parameter,
  )
}


/**
 * 辖区导出操作日志
 */
export function logExport (parameter) {
  return axios.formRequest.post(
    'log/website/log/export',
    parameter,
  )
}


